/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthenticatedRouteRouteImport } from './routes/_authenticated/route'
import { Route as ExpiredTokenRouteImport } from './routes/expired-token'
import { Route as RecoverAccountRouteImport } from './routes/recover-account'
import { Route as SignInRouteImport } from './routes/sign-in'
import { Route as UsedTokenRouteImport } from './routes/used-token'
import { Route as AuthenticatedNoBuildingRouteRouteImport } from './routes/_authenticated/_no-building/route'
import { Route as EnrollAccountTokenRouteImport } from './routes/enroll-account.$token'
import { Route as ResetPasswordTokenRouteImport } from './routes/reset-password.$token'
import { Route as AuthenticatedNoBuildingAccountRouteImport } from './routes/_authenticated/_no-building/account'
import { Route as AuthenticatedNoBuildingBuildingsRouteImport } from './routes/_authenticated/_no-building/buildings'
import { Route as AuthenticatedBuildingsBuildingIdRouteRouteImport } from './routes/_authenticated/buildings_.$buildingId/route'
import { Route as AuthenticatedNoBuildingGroupsIndexRouteImport } from './routes/_authenticated/_no-building/groups/index'
import { Route as AuthenticatedNoBuildingGroupsGroupIdRouteRouteImport } from './routes/_authenticated/_no-building/groups/$groupId/route'
import { Route as AuthenticatedNoBuildingResourcesSplatRouteImport } from './routes/_authenticated/_no-building/resources.$'
import { Route as AuthenticatedBuildingsBuildingIdIndexRouteImport } from './routes/_authenticated/buildings_.$buildingId/index'
import { Route as AuthenticatedBuildingsBuildingIdAlarmsRouteImport } from './routes/_authenticated/buildings_.$buildingId/alarms'
import { Route as AuthenticatedBuildingsBuildingIdBmsRouteImport } from './routes/_authenticated/buildings_.$buildingId/bms'
import { Route as AuthenticatedBuildingsBuildingIdConsumptionRouteRouteImport } from './routes/_authenticated/buildings_.$buildingId/consumption/route'
import { Route as AuthenticatedBuildingsBuildingIdDashboardRouteImport } from './routes/_authenticated/buildings_.$buildingId/dashboard'
import { Route as AuthenticatedBuildingsBuildingIdFloorsRouteImport } from './routes/_authenticated/buildings_.$buildingId/floors'
import { Route as AuthenticatedBuildingsBuildingIdMaintenanceRouteRouteImport } from './routes/_authenticated/buildings_.$buildingId/maintenance/route'
import { Route as AuthenticatedBuildingsBuildingIdSettingsRouteRouteImport } from './routes/_authenticated/buildings_.$buildingId/settings/route'
import { Route as AuthenticatedBuildingsBuildingIdUsersRouteImport } from './routes/_authenticated/buildings_.$buildingId/users'
import { Route as AuthenticatedNoBuildingGroupsGroupIdBuildingsRouteImport } from './routes/_authenticated/_no-building/groups/$groupId/buildings'
import { Route as AuthenticatedNoBuildingGroupsGroupIdUsersRouteImport } from './routes/_authenticated/_no-building/groups/$groupId/users'
import { Route as AuthenticatedBuildingsBuildingIdAirHandlerUnitsAirHandlerUnitIdRouteRouteImport } from './routes/_authenticated/buildings_.$buildingId/air-handler-units.$airHandlerUnitId/route'
import { Route as AuthenticatedBuildingsBuildingIdBoilerRoomsIndexRouteImport } from './routes/_authenticated/buildings_.$buildingId/boiler-rooms.index'
import { Route as AuthenticatedBuildingsBuildingIdBoilerRoomsBoilerRoomIdRouteImport } from './routes/_authenticated/buildings_.$buildingId/boiler-rooms.$boilerRoomId'
import { Route as AuthenticatedBuildingsBuildingIdConsumptionIndexRouteImport } from './routes/_authenticated/buildings_.$buildingId/consumption/index'
import { Route as AuthenticatedBuildingsBuildingIdConsumptionMeterIdRouteImport } from './routes/_authenticated/buildings_.$buildingId/consumption/$meterId'
import { Route as AuthenticatedBuildingsBuildingIdFloorsFloorIdRouteImport } from './routes/_authenticated/buildings_.$buildingId/floors_.$floorId'
import { Route as AuthenticatedBuildingsBuildingIdMaintenanceIndexRouteImport } from './routes/_authenticated/buildings_.$buildingId/maintenance/index'
import { Route as AuthenticatedBuildingsBuildingIdMaintenanceAdvancedRouteImport } from './routes/_authenticated/buildings_.$buildingId/maintenance/advanced'
import { Route as AuthenticatedBuildingsBuildingIdResourcesSplatRouteImport } from './routes/_authenticated/buildings_.$buildingId/resources.$'
import { Route as AuthenticatedBuildingsBuildingIdAirHandlerUnitsAirHandlerUnitIdIndexRouteImport } from './routes/_authenticated/buildings_.$buildingId/air-handler-units.$airHandlerUnitId/index'
import { Route as AuthenticatedBuildingsBuildingIdAirHandlerUnitsAirHandlerUnitIdSettingsRouteRouteImport } from './routes/_authenticated/buildings_.$buildingId/air-handler-units.$airHandlerUnitId/settings/route'
import { Route as AuthenticatedBuildingsBuildingIdSettingsBmsAhuGroupsRouteImport } from './routes/_authenticated/buildings_.$buildingId/settings/bms.ahu-groups'
import { Route as AuthenticatedBuildingsBuildingIdSettingsBmsModulesRouteImport } from './routes/_authenticated/buildings_.$buildingId/settings/bms.modules'
import { Route as AuthenticatedBuildingsBuildingIdSettingsBmsPagesRouteImport } from './routes/_authenticated/buildings_.$buildingId/settings/bms.pages'
import { Route as AuthenticatedBuildingsBuildingIdSettingsBuildingsGeneralRouteImport } from './routes/_authenticated/buildings_.$buildingId/settings/buildings.general'
import { Route as AuthenticatedBuildingsBuildingIdSettingsBuildingsHolidaysRouteImport } from './routes/_authenticated/buildings_.$buildingId/settings/buildings.holidays'
import { Route as AuthenticatedBuildingsBuildingIdSettingsBuildingsSeasonRouteImport } from './routes/_authenticated/buildings_.$buildingId/settings/buildings.season'
import { Route as AuthenticatedBuildingsBuildingIdSettingsBuildingsTemperaturesRouteImport } from './routes/_authenticated/buildings_.$buildingId/settings/buildings.temperatures'
import { Route as AuthenticatedBuildingsBuildingIdSettingsRoomsFunctionsRouteImport } from './routes/_authenticated/buildings_.$buildingId/settings/rooms.functions'
import { Route as AuthenticatedBuildingsBuildingIdSettingsRoomsGroupsRouteImport } from './routes/_authenticated/buildings_.$buildingId/settings/rooms.groups'
import { Route as AuthenticatedBuildingsBuildingIdSettingsRoomsHolidaysRouteImport } from './routes/_authenticated/buildings_.$buildingId/settings/rooms.holidays'
import { Route as AuthenticatedBuildingsBuildingIdSettingsRoomsPlanningRouteImport } from './routes/_authenticated/buildings_.$buildingId/settings/rooms.planning'
import { Route as AuthenticatedBuildingsBuildingIdSettingsRoomsTypeTempRouteImport } from './routes/_authenticated/buildings_.$buildingId/settings/rooms.type-temp'
import { Route as AuthenticatedBuildingsBuildingIdAirHandlerUnitsAirHandlerUnitIdSettingsFreeCoolingRouteImport } from './routes/_authenticated/buildings_.$buildingId/air-handler-units.$airHandlerUnitId/settings/free-cooling'
import { Route as AuthenticatedBuildingsBuildingIdAirHandlerUnitsAirHandlerUnitIdSettingsGeneralRouteImport } from './routes/_authenticated/buildings_.$buildingId/air-handler-units.$airHandlerUnitId/settings/general'
import { Route as AuthenticatedBuildingsBuildingIdAirHandlerUnitsAirHandlerUnitIdSettingsPlanningRouteImport } from './routes/_authenticated/buildings_.$buildingId/air-handler-units.$airHandlerUnitId/settings/planning'
import { Route as AuthenticatedBuildingsBuildingIdAirHandlerUnitsAirHandlerUnitIdSettingsSetpointRouteImport } from './routes/_authenticated/buildings_.$buildingId/air-handler-units.$airHandlerUnitId/settings/setpoint'
import { Route as AuthenticatedBuildingsBuildingIdBoilerRoomsBoilerRoomIdHeatingNetworksHeatingNetworkIdRouteImport } from './routes/_authenticated/buildings_.$buildingId/boiler-rooms_.$boilerRoomId_.heating-networks.$heatingNetworkId'
import { Route as AuthenticatedBuildingsBuildingIdFloorsFloorIdRoomsRoomIdRouteImport } from './routes/_authenticated/buildings_.$buildingId/floors_.$floorId_.rooms.$roomId'
import { Route as AuthenticatedBuildingsBuildingIdSettingsBmsModulesIndexRouteImport } from './routes/_authenticated/buildings_.$buildingId/settings/bms.modules.index'
import { Route as AuthenticatedBuildingsBuildingIdSettingsBmsModulesModuleIdRouteImport } from './routes/_authenticated/buildings_.$buildingId/settings/bms.modules.$moduleId'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRouteRoute = AuthenticatedRouteRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const ExpiredTokenRoute = ExpiredTokenRouteImport.update({
  id: '/expired-token',
  path: '/expired-token',
  getParentRoute: () => rootRouteImport,
} as any)
const RecoverAccountRoute = RecoverAccountRouteImport.update({
  id: '/recover-account',
  path: '/recover-account',
  getParentRoute: () => rootRouteImport,
} as any)
const SignInRoute = SignInRouteImport.update({
  id: '/sign-in',
  path: '/sign-in',
  getParentRoute: () => rootRouteImport,
} as any)
const UsedTokenRoute = UsedTokenRouteImport.update({
  id: '/used-token',
  path: '/used-token',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedNoBuildingRouteRoute =
  AuthenticatedNoBuildingRouteRouteImport.update({
    id: '/_no-building',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const EnrollAccountTokenRoute = EnrollAccountTokenRouteImport.update({
  id: '/enroll-account/$token',
  path: '/enroll-account/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetPasswordTokenRoute = ResetPasswordTokenRouteImport.update({
  id: '/reset-password/$token',
  path: '/reset-password/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedNoBuildingAccountRoute =
  AuthenticatedNoBuildingAccountRouteImport.update({
    id: '/account',
    path: '/account',
    getParentRoute: () => AuthenticatedNoBuildingRouteRoute,
  } as any)
const AuthenticatedNoBuildingBuildingsRoute =
  AuthenticatedNoBuildingBuildingsRouteImport.update({
    id: '/buildings',
    path: '/buildings',
    getParentRoute: () => AuthenticatedNoBuildingRouteRoute,
  } as any)
const AuthenticatedBuildingsBuildingIdRouteRoute =
  AuthenticatedBuildingsBuildingIdRouteRouteImport.update({
    id: '/buildings_/$buildingId',
    path: '/buildings/$buildingId',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedNoBuildingGroupsIndexRoute =
  AuthenticatedNoBuildingGroupsIndexRouteImport.update({
    id: '/groups/',
    path: '/groups/',
    getParentRoute: () => AuthenticatedNoBuildingRouteRoute,
  } as any)
const AuthenticatedNoBuildingGroupsGroupIdRouteRoute =
  AuthenticatedNoBuildingGroupsGroupIdRouteRouteImport.update({
    id: '/groups/$groupId',
    path: '/groups/$groupId',
    getParentRoute: () => AuthenticatedNoBuildingRouteRoute,
  } as any)
const AuthenticatedNoBuildingResourcesSplatRoute =
  AuthenticatedNoBuildingResourcesSplatRouteImport.update({
    id: '/resources/$',
    path: '/resources/$',
    getParentRoute: () => AuthenticatedNoBuildingRouteRoute,
  } as any)
const AuthenticatedBuildingsBuildingIdIndexRoute =
  AuthenticatedBuildingsBuildingIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedBuildingsBuildingIdRouteRoute,
  } as any)
const AuthenticatedBuildingsBuildingIdAlarmsRoute =
  AuthenticatedBuildingsBuildingIdAlarmsRouteImport.update({
    id: '/alarms',
    path: '/alarms',
    getParentRoute: () => AuthenticatedBuildingsBuildingIdRouteRoute,
  } as any)
const AuthenticatedBuildingsBuildingIdBmsRoute =
  AuthenticatedBuildingsBuildingIdBmsRouteImport.update({
    id: '/bms',
    path: '/bms',
    getParentRoute: () => AuthenticatedBuildingsBuildingIdRouteRoute,
  } as any)
const AuthenticatedBuildingsBuildingIdConsumptionRouteRoute =
  AuthenticatedBuildingsBuildingIdConsumptionRouteRouteImport.update({
    id: '/consumption',
    path: '/consumption',
    getParentRoute: () => AuthenticatedBuildingsBuildingIdRouteRoute,
  } as any)
const AuthenticatedBuildingsBuildingIdDashboardRoute =
  AuthenticatedBuildingsBuildingIdDashboardRouteImport.update({
    id: '/dashboard',
    path: '/dashboard',
    getParentRoute: () => AuthenticatedBuildingsBuildingIdRouteRoute,
  } as any)
const AuthenticatedBuildingsBuildingIdFloorsRoute =
  AuthenticatedBuildingsBuildingIdFloorsRouteImport.update({
    id: '/floors',
    path: '/floors',
    getParentRoute: () => AuthenticatedBuildingsBuildingIdRouteRoute,
  } as any)
const AuthenticatedBuildingsBuildingIdMaintenanceRouteRoute =
  AuthenticatedBuildingsBuildingIdMaintenanceRouteRouteImport.update({
    id: '/maintenance',
    path: '/maintenance',
    getParentRoute: () => AuthenticatedBuildingsBuildingIdRouteRoute,
  } as any)
const AuthenticatedBuildingsBuildingIdSettingsRouteRoute =
  AuthenticatedBuildingsBuildingIdSettingsRouteRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => AuthenticatedBuildingsBuildingIdRouteRoute,
  } as any)
const AuthenticatedBuildingsBuildingIdUsersRoute =
  AuthenticatedBuildingsBuildingIdUsersRouteImport.update({
    id: '/users',
    path: '/users',
    getParentRoute: () => AuthenticatedBuildingsBuildingIdRouteRoute,
  } as any)
const AuthenticatedNoBuildingGroupsGroupIdBuildingsRoute =
  AuthenticatedNoBuildingGroupsGroupIdBuildingsRouteImport.update({
    id: '/buildings',
    path: '/buildings',
    getParentRoute: () => AuthenticatedNoBuildingGroupsGroupIdRouteRoute,
  } as any)
const AuthenticatedNoBuildingGroupsGroupIdUsersRoute =
  AuthenticatedNoBuildingGroupsGroupIdUsersRouteImport.update({
    id: '/users',
    path: '/users',
    getParentRoute: () => AuthenticatedNoBuildingGroupsGroupIdRouteRoute,
  } as any)
const AuthenticatedBuildingsBuildingIdAirHandlerUnitsAirHandlerUnitIdRouteRoute =
  AuthenticatedBuildingsBuildingIdAirHandlerUnitsAirHandlerUnitIdRouteRouteImport.update(
    {
      id: '/air-handler-units/$airHandlerUnitId',
      path: '/air-handler-units/$airHandlerUnitId',
      getParentRoute: () => AuthenticatedBuildingsBuildingIdRouteRoute,
    } as any,
  )
const AuthenticatedBuildingsBuildingIdBoilerRoomsIndexRoute =
  AuthenticatedBuildingsBuildingIdBoilerRoomsIndexRouteImport.update({
    id: '/boiler-rooms/',
    path: '/boiler-rooms/',
    getParentRoute: () => AuthenticatedBuildingsBuildingIdRouteRoute,
  } as any)
const AuthenticatedBuildingsBuildingIdBoilerRoomsBoilerRoomIdRoute =
  AuthenticatedBuildingsBuildingIdBoilerRoomsBoilerRoomIdRouteImport.update({
    id: '/boiler-rooms/$boilerRoomId',
    path: '/boiler-rooms/$boilerRoomId',
    getParentRoute: () => AuthenticatedBuildingsBuildingIdRouteRoute,
  } as any)
const AuthenticatedBuildingsBuildingIdConsumptionIndexRoute =
  AuthenticatedBuildingsBuildingIdConsumptionIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedBuildingsBuildingIdConsumptionRouteRoute,
  } as any)
const AuthenticatedBuildingsBuildingIdConsumptionMeterIdRoute =
  AuthenticatedBuildingsBuildingIdConsumptionMeterIdRouteImport.update({
    id: '/$meterId',
    path: '/$meterId',
    getParentRoute: () => AuthenticatedBuildingsBuildingIdConsumptionRouteRoute,
  } as any)
const AuthenticatedBuildingsBuildingIdFloorsFloorIdRoute =
  AuthenticatedBuildingsBuildingIdFloorsFloorIdRouteImport.update({
    id: '/floors_/$floorId',
    path: '/floors/$floorId',
    getParentRoute: () => AuthenticatedBuildingsBuildingIdRouteRoute,
  } as any)
const AuthenticatedBuildingsBuildingIdMaintenanceIndexRoute =
  AuthenticatedBuildingsBuildingIdMaintenanceIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedBuildingsBuildingIdMaintenanceRouteRoute,
  } as any)
const AuthenticatedBuildingsBuildingIdMaintenanceAdvancedRoute =
  AuthenticatedBuildingsBuildingIdMaintenanceAdvancedRouteImport.update({
    id: '/advanced',
    path: '/advanced',
    getParentRoute: () => AuthenticatedBuildingsBuildingIdMaintenanceRouteRoute,
  } as any)
const AuthenticatedBuildingsBuildingIdResourcesSplatRoute =
  AuthenticatedBuildingsBuildingIdResourcesSplatRouteImport.update({
    id: '/resources/$',
    path: '/resources/$',
    getParentRoute: () => AuthenticatedBuildingsBuildingIdRouteRoute,
  } as any)
const AuthenticatedBuildingsBuildingIdAirHandlerUnitsAirHandlerUnitIdIndexRoute =
  AuthenticatedBuildingsBuildingIdAirHandlerUnitsAirHandlerUnitIdIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AuthenticatedBuildingsBuildingIdAirHandlerUnitsAirHandlerUnitIdRouteRoute,
    } as any,
  )
const AuthenticatedBuildingsBuildingIdAirHandlerUnitsAirHandlerUnitIdSettingsRouteRoute =
  AuthenticatedBuildingsBuildingIdAirHandlerUnitsAirHandlerUnitIdSettingsRouteRouteImport.update(
    {
      id: '/settings',
      path: '/settings',
      getParentRoute: () =>
        AuthenticatedBuildingsBuildingIdAirHandlerUnitsAirHandlerUnitIdRouteRoute,
    } as any,
  )
const AuthenticatedBuildingsBuildingIdSettingsBmsAhuGroupsRoute =
  AuthenticatedBuildingsBuildingIdSettingsBmsAhuGroupsRouteImport.update({
    id: '/bms/ahu-groups',
    path: '/bms/ahu-groups',
    getParentRoute: () => AuthenticatedBuildingsBuildingIdSettingsRouteRoute,
  } as any)
const AuthenticatedBuildingsBuildingIdSettingsBmsModulesRoute =
  AuthenticatedBuildingsBuildingIdSettingsBmsModulesRouteImport.update({
    id: '/bms/modules',
    path: '/bms/modules',
    getParentRoute: () => AuthenticatedBuildingsBuildingIdSettingsRouteRoute,
  } as any)
const AuthenticatedBuildingsBuildingIdSettingsBmsPagesRoute =
  AuthenticatedBuildingsBuildingIdSettingsBmsPagesRouteImport.update({
    id: '/bms/pages',
    path: '/bms/pages',
    getParentRoute: () => AuthenticatedBuildingsBuildingIdSettingsRouteRoute,
  } as any)
const AuthenticatedBuildingsBuildingIdSettingsBuildingsGeneralRoute =
  AuthenticatedBuildingsBuildingIdSettingsBuildingsGeneralRouteImport.update({
    id: '/buildings/general',
    path: '/buildings/general',
    getParentRoute: () => AuthenticatedBuildingsBuildingIdSettingsRouteRoute,
  } as any)
const AuthenticatedBuildingsBuildingIdSettingsBuildingsHolidaysRoute =
  AuthenticatedBuildingsBuildingIdSettingsBuildingsHolidaysRouteImport.update({
    id: '/buildings/holidays',
    path: '/buildings/holidays',
    getParentRoute: () => AuthenticatedBuildingsBuildingIdSettingsRouteRoute,
  } as any)
const AuthenticatedBuildingsBuildingIdSettingsBuildingsSeasonRoute =
  AuthenticatedBuildingsBuildingIdSettingsBuildingsSeasonRouteImport.update({
    id: '/buildings/season',
    path: '/buildings/season',
    getParentRoute: () => AuthenticatedBuildingsBuildingIdSettingsRouteRoute,
  } as any)
const AuthenticatedBuildingsBuildingIdSettingsBuildingsTemperaturesRoute =
  AuthenticatedBuildingsBuildingIdSettingsBuildingsTemperaturesRouteImport.update(
    {
      id: '/buildings/temperatures',
      path: '/buildings/temperatures',
      getParentRoute: () => AuthenticatedBuildingsBuildingIdSettingsRouteRoute,
    } as any,
  )
const AuthenticatedBuildingsBuildingIdSettingsRoomsFunctionsRoute =
  AuthenticatedBuildingsBuildingIdSettingsRoomsFunctionsRouteImport.update({
    id: '/rooms/functions',
    path: '/rooms/functions',
    getParentRoute: () => AuthenticatedBuildingsBuildingIdSettingsRouteRoute,
  } as any)
const AuthenticatedBuildingsBuildingIdSettingsRoomsGroupsRoute =
  AuthenticatedBuildingsBuildingIdSettingsRoomsGroupsRouteImport.update({
    id: '/rooms/groups',
    path: '/rooms/groups',
    getParentRoute: () => AuthenticatedBuildingsBuildingIdSettingsRouteRoute,
  } as any)
const AuthenticatedBuildingsBuildingIdSettingsRoomsHolidaysRoute =
  AuthenticatedBuildingsBuildingIdSettingsRoomsHolidaysRouteImport.update({
    id: '/rooms/holidays',
    path: '/rooms/holidays',
    getParentRoute: () => AuthenticatedBuildingsBuildingIdSettingsRouteRoute,
  } as any)
const AuthenticatedBuildingsBuildingIdSettingsRoomsPlanningRoute =
  AuthenticatedBuildingsBuildingIdSettingsRoomsPlanningRouteImport.update({
    id: '/rooms/planning',
    path: '/rooms/planning',
    getParentRoute: () => AuthenticatedBuildingsBuildingIdSettingsRouteRoute,
  } as any)
const AuthenticatedBuildingsBuildingIdSettingsRoomsTypeTempRoute =
  AuthenticatedBuildingsBuildingIdSettingsRoomsTypeTempRouteImport.update({
    id: '/rooms/type-temp',
    path: '/rooms/type-temp',
    getParentRoute: () => AuthenticatedBuildingsBuildingIdSettingsRouteRoute,
  } as any)
const AuthenticatedBuildingsBuildingIdAirHandlerUnitsAirHandlerUnitIdSettingsFreeCoolingRoute =
  AuthenticatedBuildingsBuildingIdAirHandlerUnitsAirHandlerUnitIdSettingsFreeCoolingRouteImport.update(
    {
      id: '/free-cooling',
      path: '/free-cooling',
      getParentRoute: () =>
        AuthenticatedBuildingsBuildingIdAirHandlerUnitsAirHandlerUnitIdSettingsRouteRoute,
    } as any,
  )
const AuthenticatedBuildingsBuildingIdAirHandlerUnitsAirHandlerUnitIdSettingsGeneralRoute =
  AuthenticatedBuildingsBuildingIdAirHandlerUnitsAirHandlerUnitIdSettingsGeneralRouteImport.update(
    {
      id: '/general',
      path: '/general',
      getParentRoute: () =>
        AuthenticatedBuildingsBuildingIdAirHandlerUnitsAirHandlerUnitIdSettingsRouteRoute,
    } as any,
  )
const AuthenticatedBuildingsBuildingIdAirHandlerUnitsAirHandlerUnitIdSettingsPlanningRoute =
  AuthenticatedBuildingsBuildingIdAirHandlerUnitsAirHandlerUnitIdSettingsPlanningRouteImport.update(
    {
      id: '/planning',
      path: '/planning',
      getParentRoute: () =>
        AuthenticatedBuildingsBuildingIdAirHandlerUnitsAirHandlerUnitIdSettingsRouteRoute,
    } as any,
  )
const AuthenticatedBuildingsBuildingIdAirHandlerUnitsAirHandlerUnitIdSettingsSetpointRoute =
  AuthenticatedBuildingsBuildingIdAirHandlerUnitsAirHandlerUnitIdSettingsSetpointRouteImport.update(
    {
      id: '/setpoint',
      path: '/setpoint',
      getParentRoute: () =>
        AuthenticatedBuildingsBuildingIdAirHandlerUnitsAirHandlerUnitIdSettingsRouteRoute,
    } as any,
  )
const AuthenticatedBuildingsBuildingIdBoilerRoomsBoilerRoomIdHeatingNetworksHeatingNetworkIdRoute =
  AuthenticatedBuildingsBuildingIdBoilerRoomsBoilerRoomIdHeatingNetworksHeatingNetworkIdRouteImport.update(
    {
      id: '/boiler-rooms_/$boilerRoomId_/heating-networks/$heatingNetworkId',
      path: '/boiler-rooms/$boilerRoomId/heating-networks/$heatingNetworkId',
      getParentRoute: () => AuthenticatedBuildingsBuildingIdRouteRoute,
    } as any,
  )
const AuthenticatedBuildingsBuildingIdFloorsFloorIdRoomsRoomIdRoute =
  AuthenticatedBuildingsBuildingIdFloorsFloorIdRoomsRoomIdRouteImport.update({
    id: '/floors_/$floorId_/rooms/$roomId',
    path: '/floors/$floorId/rooms/$roomId',
    getParentRoute: () => AuthenticatedBuildingsBuildingIdRouteRoute,
  } as any)
const AuthenticatedBuildingsBuildingIdSettingsBmsModulesIndexRoute =
  AuthenticatedBuildingsBuildingIdSettingsBmsModulesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      AuthenticatedBuildingsBuildingIdSettingsBmsModulesRoute,
  } as any)
const AuthenticatedBuildingsBuildingIdSettingsBmsModulesModuleIdRoute =
  AuthenticatedBuildingsBuildingIdSettingsBmsModulesModuleIdRouteImport.update({
    id: '/$moduleId',
    path: '/$moduleId',
    getParentRoute: () =>
      AuthenticatedBuildingsBuildingIdSettingsBmsModulesRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/expired-token': typeof ExpiredTokenRoute
  '/recover-account': typeof RecoverAccountRoute
  '/sign-in': typeof SignInRoute
  '/used-token': typeof UsedTokenRoute
  '/enroll-account/$token': typeof EnrollAccountTokenRoute
  '/reset-password/$token': typeof ResetPasswordTokenRoute
  '/buildings/$buildingId': typeof AuthenticatedBuildingsBuildingIdRouteRouteWithChildren
  '/account': typeof AuthenticatedNoBuildingAccountRoute
  '/buildings': typeof AuthenticatedNoBuildingBuildingsRoute
  '/groups/$groupId': typeof AuthenticatedNoBuildingGroupsGroupIdRouteRouteWithChildren
  '/buildings/$buildingId/consumption': typeof AuthenticatedBuildingsBuildingIdConsumptionRouteRouteWithChildren
  '/buildings/$buildingId/maintenance': typeof AuthenticatedBuildingsBuildingIdMaintenanceRouteRouteWithChildren
  '/buildings/$buildingId/settings': typeof AuthenticatedBuildingsBuildingIdSettingsRouteRouteWithChildren
  '/resources/$': typeof AuthenticatedNoBuildingResourcesSplatRoute
  '/buildings/$buildingId/alarms': typeof AuthenticatedBuildingsBuildingIdAlarmsRoute
  '/buildings/$buildingId/bms': typeof AuthenticatedBuildingsBuildingIdBmsRoute
  '/buildings/$buildingId/dashboard': typeof AuthenticatedBuildingsBuildingIdDashboardRoute
  '/buildings/$buildingId/floors': typeof AuthenticatedBuildingsBuildingIdFloorsRoute
  '/buildings/$buildingId/users': typeof AuthenticatedBuildingsBuildingIdUsersRoute
  '/groups/': typeof AuthenticatedNoBuildingGroupsIndexRoute
  '/buildings/$buildingId/': typeof AuthenticatedBuildingsBuildingIdIndexRoute
  '/buildings/$buildingId/air-handler-units/$airHandlerUnitId': typeof AuthenticatedBuildingsBuildingIdAirHandlerUnitsAirHandlerUnitIdRouteRouteWithChildren
  '/groups/$groupId/buildings': typeof AuthenticatedNoBuildingGroupsGroupIdBuildingsRoute
  '/groups/$groupId/users': typeof AuthenticatedNoBuildingGroupsGroupIdUsersRoute
  '/buildings/$buildingId/boiler-rooms/$boilerRoomId': typeof AuthenticatedBuildingsBuildingIdBoilerRoomsBoilerRoomIdRoute
  '/buildings/$buildingId/consumption/$meterId': typeof AuthenticatedBuildingsBuildingIdConsumptionMeterIdRoute
  '/buildings/$buildingId/floors/$floorId': typeof AuthenticatedBuildingsBuildingIdFloorsFloorIdRoute
  '/buildings/$buildingId/maintenance/advanced': typeof AuthenticatedBuildingsBuildingIdMaintenanceAdvancedRoute
  '/buildings/$buildingId/resources/$': typeof AuthenticatedBuildingsBuildingIdResourcesSplatRoute
  '/buildings/$buildingId/boiler-rooms/': typeof AuthenticatedBuildingsBuildingIdBoilerRoomsIndexRoute
  '/buildings/$buildingId/consumption/': typeof AuthenticatedBuildingsBuildingIdConsumptionIndexRoute
  '/buildings/$buildingId/maintenance/': typeof AuthenticatedBuildingsBuildingIdMaintenanceIndexRoute
  '/buildings/$buildingId/air-handler-units/$airHandlerUnitId/settings': typeof AuthenticatedBuildingsBuildingIdAirHandlerUnitsAirHandlerUnitIdSettingsRouteRouteWithChildren
  '/buildings/$buildingId/settings/bms/ahu-groups': typeof AuthenticatedBuildingsBuildingIdSettingsBmsAhuGroupsRoute
  '/buildings/$buildingId/settings/bms/modules': typeof AuthenticatedBuildingsBuildingIdSettingsBmsModulesRouteWithChildren
  '/buildings/$buildingId/settings/bms/pages': typeof AuthenticatedBuildingsBuildingIdSettingsBmsPagesRoute
  '/buildings/$buildingId/settings/buildings/general': typeof AuthenticatedBuildingsBuildingIdSettingsBuildingsGeneralRoute
  '/buildings/$buildingId/settings/buildings/holidays': typeof AuthenticatedBuildingsBuildingIdSettingsBuildingsHolidaysRoute
  '/buildings/$buildingId/settings/buildings/season': typeof AuthenticatedBuildingsBuildingIdSettingsBuildingsSeasonRoute
  '/buildings/$buildingId/settings/buildings/temperatures': typeof AuthenticatedBuildingsBuildingIdSettingsBuildingsTemperaturesRoute
  '/buildings/$buildingId/settings/rooms/functions': typeof AuthenticatedBuildingsBuildingIdSettingsRoomsFunctionsRoute
  '/buildings/$buildingId/settings/rooms/groups': typeof AuthenticatedBuildingsBuildingIdSettingsRoomsGroupsRoute
  '/buildings/$buildingId/settings/rooms/holidays': typeof AuthenticatedBuildingsBuildingIdSettingsRoomsHolidaysRoute
  '/buildings/$buildingId/settings/rooms/planning': typeof AuthenticatedBuildingsBuildingIdSettingsRoomsPlanningRoute
  '/buildings/$buildingId/settings/rooms/type-temp': typeof AuthenticatedBuildingsBuildingIdSettingsRoomsTypeTempRoute
  '/buildings/$buildingId/air-handler-units/$airHandlerUnitId/': typeof AuthenticatedBuildingsBuildingIdAirHandlerUnitsAirHandlerUnitIdIndexRoute
  '/buildings/$buildingId/air-handler-units/$airHandlerUnitId/settings/free-cooling': typeof AuthenticatedBuildingsBuildingIdAirHandlerUnitsAirHandlerUnitIdSettingsFreeCoolingRoute
  '/buildings/$buildingId/air-handler-units/$airHandlerUnitId/settings/general': typeof AuthenticatedBuildingsBuildingIdAirHandlerUnitsAirHandlerUnitIdSettingsGeneralRoute
  '/buildings/$buildingId/air-handler-units/$airHandlerUnitId/settings/planning': typeof AuthenticatedBuildingsBuildingIdAirHandlerUnitsAirHandlerUnitIdSettingsPlanningRoute
  '/buildings/$buildingId/air-handler-units/$airHandlerUnitId/settings/setpoint': typeof AuthenticatedBuildingsBuildingIdAirHandlerUnitsAirHandlerUnitIdSettingsSetpointRoute
  '/buildings/$buildingId/boiler-rooms/$boilerRoomId/heating-networks/$heatingNetworkId': typeof AuthenticatedBuildingsBuildingIdBoilerRoomsBoilerRoomIdHeatingNetworksHeatingNetworkIdRoute
  '/buildings/$buildingId/floors/$floorId/rooms/$roomId': typeof AuthenticatedBuildingsBuildingIdFloorsFloorIdRoomsRoomIdRoute
  '/buildings/$buildingId/settings/bms/modules/$moduleId': typeof AuthenticatedBuildingsBuildingIdSettingsBmsModulesModuleIdRoute
  '/buildings/$buildingId/settings/bms/modules/': typeof AuthenticatedBuildingsBuildingIdSettingsBmsModulesIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/expired-token': typeof ExpiredTokenRoute
  '/recover-account': typeof RecoverAccountRoute
  '/sign-in': typeof SignInRoute
  '/used-token': typeof UsedTokenRoute
  '/enroll-account/$token': typeof EnrollAccountTokenRoute
  '/reset-password/$token': typeof ResetPasswordTokenRoute
  '/account': typeof AuthenticatedNoBuildingAccountRoute
  '/buildings': typeof AuthenticatedNoBuildingBuildingsRoute
  '/groups/$groupId': typeof AuthenticatedNoBuildingGroupsGroupIdRouteRouteWithChildren
  '/buildings/$buildingId/settings': typeof AuthenticatedBuildingsBuildingIdSettingsRouteRouteWithChildren
  '/resources/$': typeof AuthenticatedNoBuildingResourcesSplatRoute
  '/buildings/$buildingId/alarms': typeof AuthenticatedBuildingsBuildingIdAlarmsRoute
  '/buildings/$buildingId/bms': typeof AuthenticatedBuildingsBuildingIdBmsRoute
  '/buildings/$buildingId/dashboard': typeof AuthenticatedBuildingsBuildingIdDashboardRoute
  '/buildings/$buildingId/floors': typeof AuthenticatedBuildingsBuildingIdFloorsRoute
  '/buildings/$buildingId/users': typeof AuthenticatedBuildingsBuildingIdUsersRoute
  '/groups': typeof AuthenticatedNoBuildingGroupsIndexRoute
  '/buildings/$buildingId': typeof AuthenticatedBuildingsBuildingIdIndexRoute
  '/groups/$groupId/buildings': typeof AuthenticatedNoBuildingGroupsGroupIdBuildingsRoute
  '/groups/$groupId/users': typeof AuthenticatedNoBuildingGroupsGroupIdUsersRoute
  '/buildings/$buildingId/boiler-rooms/$boilerRoomId': typeof AuthenticatedBuildingsBuildingIdBoilerRoomsBoilerRoomIdRoute
  '/buildings/$buildingId/consumption/$meterId': typeof AuthenticatedBuildingsBuildingIdConsumptionMeterIdRoute
  '/buildings/$buildingId/floors/$floorId': typeof AuthenticatedBuildingsBuildingIdFloorsFloorIdRoute
  '/buildings/$buildingId/maintenance/advanced': typeof AuthenticatedBuildingsBuildingIdMaintenanceAdvancedRoute
  '/buildings/$buildingId/resources/$': typeof AuthenticatedBuildingsBuildingIdResourcesSplatRoute
  '/buildings/$buildingId/boiler-rooms': typeof AuthenticatedBuildingsBuildingIdBoilerRoomsIndexRoute
  '/buildings/$buildingId/consumption': typeof AuthenticatedBuildingsBuildingIdConsumptionIndexRoute
  '/buildings/$buildingId/maintenance': typeof AuthenticatedBuildingsBuildingIdMaintenanceIndexRoute
  '/buildings/$buildingId/air-handler-units/$airHandlerUnitId/settings': typeof AuthenticatedBuildingsBuildingIdAirHandlerUnitsAirHandlerUnitIdSettingsRouteRouteWithChildren
  '/buildings/$buildingId/settings/bms/ahu-groups': typeof AuthenticatedBuildingsBuildingIdSettingsBmsAhuGroupsRoute
  '/buildings/$buildingId/settings/bms/pages': typeof AuthenticatedBuildingsBuildingIdSettingsBmsPagesRoute
  '/buildings/$buildingId/settings/buildings/general': typeof AuthenticatedBuildingsBuildingIdSettingsBuildingsGeneralRoute
  '/buildings/$buildingId/settings/buildings/holidays': typeof AuthenticatedBuildingsBuildingIdSettingsBuildingsHolidaysRoute
  '/buildings/$buildingId/settings/buildings/season': typeof AuthenticatedBuildingsBuildingIdSettingsBuildingsSeasonRoute
  '/buildings/$buildingId/settings/buildings/temperatures': typeof AuthenticatedBuildingsBuildingIdSettingsBuildingsTemperaturesRoute
  '/buildings/$buildingId/settings/rooms/functions': typeof AuthenticatedBuildingsBuildingIdSettingsRoomsFunctionsRoute
  '/buildings/$buildingId/settings/rooms/groups': typeof AuthenticatedBuildingsBuildingIdSettingsRoomsGroupsRoute
  '/buildings/$buildingId/settings/rooms/holidays': typeof AuthenticatedBuildingsBuildingIdSettingsRoomsHolidaysRoute
  '/buildings/$buildingId/settings/rooms/planning': typeof AuthenticatedBuildingsBuildingIdSettingsRoomsPlanningRoute
  '/buildings/$buildingId/settings/rooms/type-temp': typeof AuthenticatedBuildingsBuildingIdSettingsRoomsTypeTempRoute
  '/buildings/$buildingId/air-handler-units/$airHandlerUnitId': typeof AuthenticatedBuildingsBuildingIdAirHandlerUnitsAirHandlerUnitIdIndexRoute
  '/buildings/$buildingId/air-handler-units/$airHandlerUnitId/settings/free-cooling': typeof AuthenticatedBuildingsBuildingIdAirHandlerUnitsAirHandlerUnitIdSettingsFreeCoolingRoute
  '/buildings/$buildingId/air-handler-units/$airHandlerUnitId/settings/general': typeof AuthenticatedBuildingsBuildingIdAirHandlerUnitsAirHandlerUnitIdSettingsGeneralRoute
  '/buildings/$buildingId/air-handler-units/$airHandlerUnitId/settings/planning': typeof AuthenticatedBuildingsBuildingIdAirHandlerUnitsAirHandlerUnitIdSettingsPlanningRoute
  '/buildings/$buildingId/air-handler-units/$airHandlerUnitId/settings/setpoint': typeof AuthenticatedBuildingsBuildingIdAirHandlerUnitsAirHandlerUnitIdSettingsSetpointRoute
  '/buildings/$buildingId/boiler-rooms/$boilerRoomId/heating-networks/$heatingNetworkId': typeof AuthenticatedBuildingsBuildingIdBoilerRoomsBoilerRoomIdHeatingNetworksHeatingNetworkIdRoute
  '/buildings/$buildingId/floors/$floorId/rooms/$roomId': typeof AuthenticatedBuildingsBuildingIdFloorsFloorIdRoomsRoomIdRoute
  '/buildings/$buildingId/settings/bms/modules/$moduleId': typeof AuthenticatedBuildingsBuildingIdSettingsBmsModulesModuleIdRoute
  '/buildings/$buildingId/settings/bms/modules': typeof AuthenticatedBuildingsBuildingIdSettingsBmsModulesIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_authenticated': typeof AuthenticatedRouteRouteWithChildren
  '/expired-token': typeof ExpiredTokenRoute
  '/recover-account': typeof RecoverAccountRoute
  '/sign-in': typeof SignInRoute
  '/used-token': typeof UsedTokenRoute
  '/_authenticated/_no-building': typeof AuthenticatedNoBuildingRouteRouteWithChildren
  '/enroll-account/$token': typeof EnrollAccountTokenRoute
  '/reset-password/$token': typeof ResetPasswordTokenRoute
  '/_authenticated/buildings_/$buildingId': typeof AuthenticatedBuildingsBuildingIdRouteRouteWithChildren
  '/_authenticated/_no-building/account': typeof AuthenticatedNoBuildingAccountRoute
  '/_authenticated/_no-building/buildings': typeof AuthenticatedNoBuildingBuildingsRoute
  '/_authenticated/_no-building/groups/$groupId': typeof AuthenticatedNoBuildingGroupsGroupIdRouteRouteWithChildren
  '/_authenticated/buildings_/$buildingId/consumption': typeof AuthenticatedBuildingsBuildingIdConsumptionRouteRouteWithChildren
  '/_authenticated/buildings_/$buildingId/maintenance': typeof AuthenticatedBuildingsBuildingIdMaintenanceRouteRouteWithChildren
  '/_authenticated/buildings_/$buildingId/settings': typeof AuthenticatedBuildingsBuildingIdSettingsRouteRouteWithChildren
  '/_authenticated/_no-building/resources/$': typeof AuthenticatedNoBuildingResourcesSplatRoute
  '/_authenticated/buildings_/$buildingId/alarms': typeof AuthenticatedBuildingsBuildingIdAlarmsRoute
  '/_authenticated/buildings_/$buildingId/bms': typeof AuthenticatedBuildingsBuildingIdBmsRoute
  '/_authenticated/buildings_/$buildingId/dashboard': typeof AuthenticatedBuildingsBuildingIdDashboardRoute
  '/_authenticated/buildings_/$buildingId/floors': typeof AuthenticatedBuildingsBuildingIdFloorsRoute
  '/_authenticated/buildings_/$buildingId/users': typeof AuthenticatedBuildingsBuildingIdUsersRoute
  '/_authenticated/_no-building/groups/': typeof AuthenticatedNoBuildingGroupsIndexRoute
  '/_authenticated/buildings_/$buildingId/': typeof AuthenticatedBuildingsBuildingIdIndexRoute
  '/_authenticated/buildings_/$buildingId/air-handler-units/$airHandlerUnitId': typeof AuthenticatedBuildingsBuildingIdAirHandlerUnitsAirHandlerUnitIdRouteRouteWithChildren
  '/_authenticated/_no-building/groups/$groupId/buildings': typeof AuthenticatedNoBuildingGroupsGroupIdBuildingsRoute
  '/_authenticated/_no-building/groups/$groupId/users': typeof AuthenticatedNoBuildingGroupsGroupIdUsersRoute
  '/_authenticated/buildings_/$buildingId/boiler-rooms/$boilerRoomId': typeof AuthenticatedBuildingsBuildingIdBoilerRoomsBoilerRoomIdRoute
  '/_authenticated/buildings_/$buildingId/consumption/$meterId': typeof AuthenticatedBuildingsBuildingIdConsumptionMeterIdRoute
  '/_authenticated/buildings_/$buildingId/floors_/$floorId': typeof AuthenticatedBuildingsBuildingIdFloorsFloorIdRoute
  '/_authenticated/buildings_/$buildingId/maintenance/advanced': typeof AuthenticatedBuildingsBuildingIdMaintenanceAdvancedRoute
  '/_authenticated/buildings_/$buildingId/resources/$': typeof AuthenticatedBuildingsBuildingIdResourcesSplatRoute
  '/_authenticated/buildings_/$buildingId/boiler-rooms/': typeof AuthenticatedBuildingsBuildingIdBoilerRoomsIndexRoute
  '/_authenticated/buildings_/$buildingId/consumption/': typeof AuthenticatedBuildingsBuildingIdConsumptionIndexRoute
  '/_authenticated/buildings_/$buildingId/maintenance/': typeof AuthenticatedBuildingsBuildingIdMaintenanceIndexRoute
  '/_authenticated/buildings_/$buildingId/air-handler-units/$airHandlerUnitId/settings': typeof AuthenticatedBuildingsBuildingIdAirHandlerUnitsAirHandlerUnitIdSettingsRouteRouteWithChildren
  '/_authenticated/buildings_/$buildingId/settings/bms/ahu-groups': typeof AuthenticatedBuildingsBuildingIdSettingsBmsAhuGroupsRoute
  '/_authenticated/buildings_/$buildingId/settings/bms/modules': typeof AuthenticatedBuildingsBuildingIdSettingsBmsModulesRouteWithChildren
  '/_authenticated/buildings_/$buildingId/settings/bms/pages': typeof AuthenticatedBuildingsBuildingIdSettingsBmsPagesRoute
  '/_authenticated/buildings_/$buildingId/settings/buildings/general': typeof AuthenticatedBuildingsBuildingIdSettingsBuildingsGeneralRoute
  '/_authenticated/buildings_/$buildingId/settings/buildings/holidays': typeof AuthenticatedBuildingsBuildingIdSettingsBuildingsHolidaysRoute
  '/_authenticated/buildings_/$buildingId/settings/buildings/season': typeof AuthenticatedBuildingsBuildingIdSettingsBuildingsSeasonRoute
  '/_authenticated/buildings_/$buildingId/settings/buildings/temperatures': typeof AuthenticatedBuildingsBuildingIdSettingsBuildingsTemperaturesRoute
  '/_authenticated/buildings_/$buildingId/settings/rooms/functions': typeof AuthenticatedBuildingsBuildingIdSettingsRoomsFunctionsRoute
  '/_authenticated/buildings_/$buildingId/settings/rooms/groups': typeof AuthenticatedBuildingsBuildingIdSettingsRoomsGroupsRoute
  '/_authenticated/buildings_/$buildingId/settings/rooms/holidays': typeof AuthenticatedBuildingsBuildingIdSettingsRoomsHolidaysRoute
  '/_authenticated/buildings_/$buildingId/settings/rooms/planning': typeof AuthenticatedBuildingsBuildingIdSettingsRoomsPlanningRoute
  '/_authenticated/buildings_/$buildingId/settings/rooms/type-temp': typeof AuthenticatedBuildingsBuildingIdSettingsRoomsTypeTempRoute
  '/_authenticated/buildings_/$buildingId/air-handler-units/$airHandlerUnitId/': typeof AuthenticatedBuildingsBuildingIdAirHandlerUnitsAirHandlerUnitIdIndexRoute
  '/_authenticated/buildings_/$buildingId/air-handler-units/$airHandlerUnitId/settings/free-cooling': typeof AuthenticatedBuildingsBuildingIdAirHandlerUnitsAirHandlerUnitIdSettingsFreeCoolingRoute
  '/_authenticated/buildings_/$buildingId/air-handler-units/$airHandlerUnitId/settings/general': typeof AuthenticatedBuildingsBuildingIdAirHandlerUnitsAirHandlerUnitIdSettingsGeneralRoute
  '/_authenticated/buildings_/$buildingId/air-handler-units/$airHandlerUnitId/settings/planning': typeof AuthenticatedBuildingsBuildingIdAirHandlerUnitsAirHandlerUnitIdSettingsPlanningRoute
  '/_authenticated/buildings_/$buildingId/air-handler-units/$airHandlerUnitId/settings/setpoint': typeof AuthenticatedBuildingsBuildingIdAirHandlerUnitsAirHandlerUnitIdSettingsSetpointRoute
  '/_authenticated/buildings_/$buildingId/boiler-rooms_/$boilerRoomId_/heating-networks/$heatingNetworkId': typeof AuthenticatedBuildingsBuildingIdBoilerRoomsBoilerRoomIdHeatingNetworksHeatingNetworkIdRoute
  '/_authenticated/buildings_/$buildingId/floors_/$floorId_/rooms/$roomId': typeof AuthenticatedBuildingsBuildingIdFloorsFloorIdRoomsRoomIdRoute
  '/_authenticated/buildings_/$buildingId/settings/bms/modules/$moduleId': typeof AuthenticatedBuildingsBuildingIdSettingsBmsModulesModuleIdRoute
  '/_authenticated/buildings_/$buildingId/settings/bms/modules/': typeof AuthenticatedBuildingsBuildingIdSettingsBmsModulesIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/expired-token'
    | '/recover-account'
    | '/sign-in'
    | '/used-token'
    | '/enroll-account/$token'
    | '/reset-password/$token'
    | '/buildings/$buildingId'
    | '/account'
    | '/buildings'
    | '/groups/$groupId'
    | '/buildings/$buildingId/consumption'
    | '/buildings/$buildingId/maintenance'
    | '/buildings/$buildingId/settings'
    | '/resources/$'
    | '/buildings/$buildingId/alarms'
    | '/buildings/$buildingId/bms'
    | '/buildings/$buildingId/dashboard'
    | '/buildings/$buildingId/floors'
    | '/buildings/$buildingId/users'
    | '/groups/'
    | '/buildings/$buildingId/'
    | '/buildings/$buildingId/air-handler-units/$airHandlerUnitId'
    | '/groups/$groupId/buildings'
    | '/groups/$groupId/users'
    | '/buildings/$buildingId/boiler-rooms/$boilerRoomId'
    | '/buildings/$buildingId/consumption/$meterId'
    | '/buildings/$buildingId/floors/$floorId'
    | '/buildings/$buildingId/maintenance/advanced'
    | '/buildings/$buildingId/resources/$'
    | '/buildings/$buildingId/boiler-rooms/'
    | '/buildings/$buildingId/consumption/'
    | '/buildings/$buildingId/maintenance/'
    | '/buildings/$buildingId/air-handler-units/$airHandlerUnitId/settings'
    | '/buildings/$buildingId/settings/bms/ahu-groups'
    | '/buildings/$buildingId/settings/bms/modules'
    | '/buildings/$buildingId/settings/bms/pages'
    | '/buildings/$buildingId/settings/buildings/general'
    | '/buildings/$buildingId/settings/buildings/holidays'
    | '/buildings/$buildingId/settings/buildings/season'
    | '/buildings/$buildingId/settings/buildings/temperatures'
    | '/buildings/$buildingId/settings/rooms/functions'
    | '/buildings/$buildingId/settings/rooms/groups'
    | '/buildings/$buildingId/settings/rooms/holidays'
    | '/buildings/$buildingId/settings/rooms/planning'
    | '/buildings/$buildingId/settings/rooms/type-temp'
    | '/buildings/$buildingId/air-handler-units/$airHandlerUnitId/'
    | '/buildings/$buildingId/air-handler-units/$airHandlerUnitId/settings/free-cooling'
    | '/buildings/$buildingId/air-handler-units/$airHandlerUnitId/settings/general'
    | '/buildings/$buildingId/air-handler-units/$airHandlerUnitId/settings/planning'
    | '/buildings/$buildingId/air-handler-units/$airHandlerUnitId/settings/setpoint'
    | '/buildings/$buildingId/boiler-rooms/$boilerRoomId/heating-networks/$heatingNetworkId'
    | '/buildings/$buildingId/floors/$floorId/rooms/$roomId'
    | '/buildings/$buildingId/settings/bms/modules/$moduleId'
    | '/buildings/$buildingId/settings/bms/modules/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/expired-token'
    | '/recover-account'
    | '/sign-in'
    | '/used-token'
    | '/enroll-account/$token'
    | '/reset-password/$token'
    | '/account'
    | '/buildings'
    | '/groups/$groupId'
    | '/buildings/$buildingId/settings'
    | '/resources/$'
    | '/buildings/$buildingId/alarms'
    | '/buildings/$buildingId/bms'
    | '/buildings/$buildingId/dashboard'
    | '/buildings/$buildingId/floors'
    | '/buildings/$buildingId/users'
    | '/groups'
    | '/buildings/$buildingId'
    | '/groups/$groupId/buildings'
    | '/groups/$groupId/users'
    | '/buildings/$buildingId/boiler-rooms/$boilerRoomId'
    | '/buildings/$buildingId/consumption/$meterId'
    | '/buildings/$buildingId/floors/$floorId'
    | '/buildings/$buildingId/maintenance/advanced'
    | '/buildings/$buildingId/resources/$'
    | '/buildings/$buildingId/boiler-rooms'
    | '/buildings/$buildingId/consumption'
    | '/buildings/$buildingId/maintenance'
    | '/buildings/$buildingId/air-handler-units/$airHandlerUnitId/settings'
    | '/buildings/$buildingId/settings/bms/ahu-groups'
    | '/buildings/$buildingId/settings/bms/pages'
    | '/buildings/$buildingId/settings/buildings/general'
    | '/buildings/$buildingId/settings/buildings/holidays'
    | '/buildings/$buildingId/settings/buildings/season'
    | '/buildings/$buildingId/settings/buildings/temperatures'
    | '/buildings/$buildingId/settings/rooms/functions'
    | '/buildings/$buildingId/settings/rooms/groups'
    | '/buildings/$buildingId/settings/rooms/holidays'
    | '/buildings/$buildingId/settings/rooms/planning'
    | '/buildings/$buildingId/settings/rooms/type-temp'
    | '/buildings/$buildingId/air-handler-units/$airHandlerUnitId'
    | '/buildings/$buildingId/air-handler-units/$airHandlerUnitId/settings/free-cooling'
    | '/buildings/$buildingId/air-handler-units/$airHandlerUnitId/settings/general'
    | '/buildings/$buildingId/air-handler-units/$airHandlerUnitId/settings/planning'
    | '/buildings/$buildingId/air-handler-units/$airHandlerUnitId/settings/setpoint'
    | '/buildings/$buildingId/boiler-rooms/$boilerRoomId/heating-networks/$heatingNetworkId'
    | '/buildings/$buildingId/floors/$floorId/rooms/$roomId'
    | '/buildings/$buildingId/settings/bms/modules/$moduleId'
    | '/buildings/$buildingId/settings/bms/modules'
  id:
    | '__root__'
    | '/'
    | '/_authenticated'
    | '/expired-token'
    | '/recover-account'
    | '/sign-in'
    | '/used-token'
    | '/_authenticated/_no-building'
    | '/enroll-account/$token'
    | '/reset-password/$token'
    | '/_authenticated/buildings_/$buildingId'
    | '/_authenticated/_no-building/account'
    | '/_authenticated/_no-building/buildings'
    | '/_authenticated/_no-building/groups/$groupId'
    | '/_authenticated/buildings_/$buildingId/consumption'
    | '/_authenticated/buildings_/$buildingId/maintenance'
    | '/_authenticated/buildings_/$buildingId/settings'
    | '/_authenticated/_no-building/resources/$'
    | '/_authenticated/buildings_/$buildingId/alarms'
    | '/_authenticated/buildings_/$buildingId/bms'
    | '/_authenticated/buildings_/$buildingId/dashboard'
    | '/_authenticated/buildings_/$buildingId/floors'
    | '/_authenticated/buildings_/$buildingId/users'
    | '/_authenticated/_no-building/groups/'
    | '/_authenticated/buildings_/$buildingId/'
    | '/_authenticated/buildings_/$buildingId/air-handler-units/$airHandlerUnitId'
    | '/_authenticated/_no-building/groups/$groupId/buildings'
    | '/_authenticated/_no-building/groups/$groupId/users'
    | '/_authenticated/buildings_/$buildingId/boiler-rooms/$boilerRoomId'
    | '/_authenticated/buildings_/$buildingId/consumption/$meterId'
    | '/_authenticated/buildings_/$buildingId/floors_/$floorId'
    | '/_authenticated/buildings_/$buildingId/maintenance/advanced'
    | '/_authenticated/buildings_/$buildingId/resources/$'
    | '/_authenticated/buildings_/$buildingId/boiler-rooms/'
    | '/_authenticated/buildings_/$buildingId/consumption/'
    | '/_authenticated/buildings_/$buildingId/maintenance/'
    | '/_authenticated/buildings_/$buildingId/air-handler-units/$airHandlerUnitId/settings'
    | '/_authenticated/buildings_/$buildingId/settings/bms/ahu-groups'
    | '/_authenticated/buildings_/$buildingId/settings/bms/modules'
    | '/_authenticated/buildings_/$buildingId/settings/bms/pages'
    | '/_authenticated/buildings_/$buildingId/settings/buildings/general'
    | '/_authenticated/buildings_/$buildingId/settings/buildings/holidays'
    | '/_authenticated/buildings_/$buildingId/settings/buildings/season'
    | '/_authenticated/buildings_/$buildingId/settings/buildings/temperatures'
    | '/_authenticated/buildings_/$buildingId/settings/rooms/functions'
    | '/_authenticated/buildings_/$buildingId/settings/rooms/groups'
    | '/_authenticated/buildings_/$buildingId/settings/rooms/holidays'
    | '/_authenticated/buildings_/$buildingId/settings/rooms/planning'
    | '/_authenticated/buildings_/$buildingId/settings/rooms/type-temp'
    | '/_authenticated/buildings_/$buildingId/air-handler-units/$airHandlerUnitId/'
    | '/_authenticated/buildings_/$buildingId/air-handler-units/$airHandlerUnitId/settings/free-cooling'
    | '/_authenticated/buildings_/$buildingId/air-handler-units/$airHandlerUnitId/settings/general'
    | '/_authenticated/buildings_/$buildingId/air-handler-units/$airHandlerUnitId/settings/planning'
    | '/_authenticated/buildings_/$buildingId/air-handler-units/$airHandlerUnitId/settings/setpoint'
    | '/_authenticated/buildings_/$buildingId/boiler-rooms_/$boilerRoomId_/heating-networks/$heatingNetworkId'
    | '/_authenticated/buildings_/$buildingId/floors_/$floorId_/rooms/$roomId'
    | '/_authenticated/buildings_/$buildingId/settings/bms/modules/$moduleId'
    | '/_authenticated/buildings_/$buildingId/settings/bms/modules/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthenticatedRouteRoute: typeof AuthenticatedRouteRouteWithChildren
  ExpiredTokenRoute: typeof ExpiredTokenRoute
  RecoverAccountRoute: typeof RecoverAccountRoute
  SignInRoute: typeof SignInRoute
  UsedTokenRoute: typeof UsedTokenRoute
  EnrollAccountTokenRoute: typeof EnrollAccountTokenRoute
  ResetPasswordTokenRoute: typeof ResetPasswordTokenRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/expired-token': {
      id: '/expired-token'
      path: '/expired-token'
      fullPath: '/expired-token'
      preLoaderRoute: typeof ExpiredTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/recover-account': {
      id: '/recover-account'
      path: '/recover-account'
      fullPath: '/recover-account'
      preLoaderRoute: typeof RecoverAccountRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sign-in': {
      id: '/sign-in'
      path: '/sign-in'
      fullPath: '/sign-in'
      preLoaderRoute: typeof SignInRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/used-token': {
      id: '/used-token'
      path: '/used-token'
      fullPath: '/used-token'
      preLoaderRoute: typeof UsedTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/_no-building': {
      id: '/_authenticated/_no-building'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedNoBuildingRouteRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/enroll-account/$token': {
      id: '/enroll-account/$token'
      path: '/enroll-account/$token'
      fullPath: '/enroll-account/$token'
      preLoaderRoute: typeof EnrollAccountTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-password/$token': {
      id: '/reset-password/$token'
      path: '/reset-password/$token'
      fullPath: '/reset-password/$token'
      preLoaderRoute: typeof ResetPasswordTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/_no-building/account': {
      id: '/_authenticated/_no-building/account'
      path: '/account'
      fullPath: '/account'
      preLoaderRoute: typeof AuthenticatedNoBuildingAccountRouteImport
      parentRoute: typeof AuthenticatedNoBuildingRouteRoute
    }
    '/_authenticated/_no-building/buildings': {
      id: '/_authenticated/_no-building/buildings'
      path: '/buildings'
      fullPath: '/buildings'
      preLoaderRoute: typeof AuthenticatedNoBuildingBuildingsRouteImport
      parentRoute: typeof AuthenticatedNoBuildingRouteRoute
    }
    '/_authenticated/buildings_/$buildingId': {
      id: '/_authenticated/buildings_/$buildingId'
      path: '/buildings/$buildingId'
      fullPath: '/buildings/$buildingId'
      preLoaderRoute: typeof AuthenticatedBuildingsBuildingIdRouteRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/_no-building/groups/': {
      id: '/_authenticated/_no-building/groups/'
      path: '/groups'
      fullPath: '/groups/'
      preLoaderRoute: typeof AuthenticatedNoBuildingGroupsIndexRouteImport
      parentRoute: typeof AuthenticatedNoBuildingRouteRoute
    }
    '/_authenticated/_no-building/groups/$groupId': {
      id: '/_authenticated/_no-building/groups/$groupId'
      path: '/groups/$groupId'
      fullPath: '/groups/$groupId'
      preLoaderRoute: typeof AuthenticatedNoBuildingGroupsGroupIdRouteRouteImport
      parentRoute: typeof AuthenticatedNoBuildingRouteRoute
    }
    '/_authenticated/_no-building/resources/$': {
      id: '/_authenticated/_no-building/resources/$'
      path: '/resources/$'
      fullPath: '/resources/$'
      preLoaderRoute: typeof AuthenticatedNoBuildingResourcesSplatRouteImport
      parentRoute: typeof AuthenticatedNoBuildingRouteRoute
    }
    '/_authenticated/buildings_/$buildingId/': {
      id: '/_authenticated/buildings_/$buildingId/'
      path: '/'
      fullPath: '/buildings/$buildingId/'
      preLoaderRoute: typeof AuthenticatedBuildingsBuildingIdIndexRouteImport
      parentRoute: typeof AuthenticatedBuildingsBuildingIdRouteRoute
    }
    '/_authenticated/buildings_/$buildingId/alarms': {
      id: '/_authenticated/buildings_/$buildingId/alarms'
      path: '/alarms'
      fullPath: '/buildings/$buildingId/alarms'
      preLoaderRoute: typeof AuthenticatedBuildingsBuildingIdAlarmsRouteImport
      parentRoute: typeof AuthenticatedBuildingsBuildingIdRouteRoute
    }
    '/_authenticated/buildings_/$buildingId/bms': {
      id: '/_authenticated/buildings_/$buildingId/bms'
      path: '/bms'
      fullPath: '/buildings/$buildingId/bms'
      preLoaderRoute: typeof AuthenticatedBuildingsBuildingIdBmsRouteImport
      parentRoute: typeof AuthenticatedBuildingsBuildingIdRouteRoute
    }
    '/_authenticated/buildings_/$buildingId/consumption': {
      id: '/_authenticated/buildings_/$buildingId/consumption'
      path: '/consumption'
      fullPath: '/buildings/$buildingId/consumption'
      preLoaderRoute: typeof AuthenticatedBuildingsBuildingIdConsumptionRouteRouteImport
      parentRoute: typeof AuthenticatedBuildingsBuildingIdRouteRoute
    }
    '/_authenticated/buildings_/$buildingId/dashboard': {
      id: '/_authenticated/buildings_/$buildingId/dashboard'
      path: '/dashboard'
      fullPath: '/buildings/$buildingId/dashboard'
      preLoaderRoute: typeof AuthenticatedBuildingsBuildingIdDashboardRouteImport
      parentRoute: typeof AuthenticatedBuildingsBuildingIdRouteRoute
    }
    '/_authenticated/buildings_/$buildingId/floors': {
      id: '/_authenticated/buildings_/$buildingId/floors'
      path: '/floors'
      fullPath: '/buildings/$buildingId/floors'
      preLoaderRoute: typeof AuthenticatedBuildingsBuildingIdFloorsRouteImport
      parentRoute: typeof AuthenticatedBuildingsBuildingIdRouteRoute
    }
    '/_authenticated/buildings_/$buildingId/maintenance': {
      id: '/_authenticated/buildings_/$buildingId/maintenance'
      path: '/maintenance'
      fullPath: '/buildings/$buildingId/maintenance'
      preLoaderRoute: typeof AuthenticatedBuildingsBuildingIdMaintenanceRouteRouteImport
      parentRoute: typeof AuthenticatedBuildingsBuildingIdRouteRoute
    }
    '/_authenticated/buildings_/$buildingId/settings': {
      id: '/_authenticated/buildings_/$buildingId/settings'
      path: '/settings'
      fullPath: '/buildings/$buildingId/settings'
      preLoaderRoute: typeof AuthenticatedBuildingsBuildingIdSettingsRouteRouteImport
      parentRoute: typeof AuthenticatedBuildingsBuildingIdRouteRoute
    }
    '/_authenticated/buildings_/$buildingId/users': {
      id: '/_authenticated/buildings_/$buildingId/users'
      path: '/users'
      fullPath: '/buildings/$buildingId/users'
      preLoaderRoute: typeof AuthenticatedBuildingsBuildingIdUsersRouteImport
      parentRoute: typeof AuthenticatedBuildingsBuildingIdRouteRoute
    }
    '/_authenticated/_no-building/groups/$groupId/buildings': {
      id: '/_authenticated/_no-building/groups/$groupId/buildings'
      path: '/buildings'
      fullPath: '/groups/$groupId/buildings'
      preLoaderRoute: typeof AuthenticatedNoBuildingGroupsGroupIdBuildingsRouteImport
      parentRoute: typeof AuthenticatedNoBuildingGroupsGroupIdRouteRoute
    }
    '/_authenticated/_no-building/groups/$groupId/users': {
      id: '/_authenticated/_no-building/groups/$groupId/users'
      path: '/users'
      fullPath: '/groups/$groupId/users'
      preLoaderRoute: typeof AuthenticatedNoBuildingGroupsGroupIdUsersRouteImport
      parentRoute: typeof AuthenticatedNoBuildingGroupsGroupIdRouteRoute
    }
    '/_authenticated/buildings_/$buildingId/air-handler-units/$airHandlerUnitId': {
      id: '/_authenticated/buildings_/$buildingId/air-handler-units/$airHandlerUnitId'
      path: '/air-handler-units/$airHandlerUnitId'
      fullPath: '/buildings/$buildingId/air-handler-units/$airHandlerUnitId'
      preLoaderRoute: typeof AuthenticatedBuildingsBuildingIdAirHandlerUnitsAirHandlerUnitIdRouteRouteImport
      parentRoute: typeof AuthenticatedBuildingsBuildingIdRouteRoute
    }
    '/_authenticated/buildings_/$buildingId/boiler-rooms/': {
      id: '/_authenticated/buildings_/$buildingId/boiler-rooms/'
      path: '/boiler-rooms'
      fullPath: '/buildings/$buildingId/boiler-rooms/'
      preLoaderRoute: typeof AuthenticatedBuildingsBuildingIdBoilerRoomsIndexRouteImport
      parentRoute: typeof AuthenticatedBuildingsBuildingIdRouteRoute
    }
    '/_authenticated/buildings_/$buildingId/boiler-rooms/$boilerRoomId': {
      id: '/_authenticated/buildings_/$buildingId/boiler-rooms/$boilerRoomId'
      path: '/boiler-rooms/$boilerRoomId'
      fullPath: '/buildings/$buildingId/boiler-rooms/$boilerRoomId'
      preLoaderRoute: typeof AuthenticatedBuildingsBuildingIdBoilerRoomsBoilerRoomIdRouteImport
      parentRoute: typeof AuthenticatedBuildingsBuildingIdRouteRoute
    }
    '/_authenticated/buildings_/$buildingId/consumption/': {
      id: '/_authenticated/buildings_/$buildingId/consumption/'
      path: '/'
      fullPath: '/buildings/$buildingId/consumption/'
      preLoaderRoute: typeof AuthenticatedBuildingsBuildingIdConsumptionIndexRouteImport
      parentRoute: typeof AuthenticatedBuildingsBuildingIdConsumptionRouteRoute
    }
    '/_authenticated/buildings_/$buildingId/consumption/$meterId': {
      id: '/_authenticated/buildings_/$buildingId/consumption/$meterId'
      path: '/$meterId'
      fullPath: '/buildings/$buildingId/consumption/$meterId'
      preLoaderRoute: typeof AuthenticatedBuildingsBuildingIdConsumptionMeterIdRouteImport
      parentRoute: typeof AuthenticatedBuildingsBuildingIdConsumptionRouteRoute
    }
    '/_authenticated/buildings_/$buildingId/floors_/$floorId': {
      id: '/_authenticated/buildings_/$buildingId/floors_/$floorId'
      path: '/floors/$floorId'
      fullPath: '/buildings/$buildingId/floors/$floorId'
      preLoaderRoute: typeof AuthenticatedBuildingsBuildingIdFloorsFloorIdRouteImport
      parentRoute: typeof AuthenticatedBuildingsBuildingIdRouteRoute
    }
    '/_authenticated/buildings_/$buildingId/maintenance/': {
      id: '/_authenticated/buildings_/$buildingId/maintenance/'
      path: '/'
      fullPath: '/buildings/$buildingId/maintenance/'
      preLoaderRoute: typeof AuthenticatedBuildingsBuildingIdMaintenanceIndexRouteImport
      parentRoute: typeof AuthenticatedBuildingsBuildingIdMaintenanceRouteRoute
    }
    '/_authenticated/buildings_/$buildingId/maintenance/advanced': {
      id: '/_authenticated/buildings_/$buildingId/maintenance/advanced'
      path: '/advanced'
      fullPath: '/buildings/$buildingId/maintenance/advanced'
      preLoaderRoute: typeof AuthenticatedBuildingsBuildingIdMaintenanceAdvancedRouteImport
      parentRoute: typeof AuthenticatedBuildingsBuildingIdMaintenanceRouteRoute
    }
    '/_authenticated/buildings_/$buildingId/resources/$': {
      id: '/_authenticated/buildings_/$buildingId/resources/$'
      path: '/resources/$'
      fullPath: '/buildings/$buildingId/resources/$'
      preLoaderRoute: typeof AuthenticatedBuildingsBuildingIdResourcesSplatRouteImport
      parentRoute: typeof AuthenticatedBuildingsBuildingIdRouteRoute
    }
    '/_authenticated/buildings_/$buildingId/air-handler-units/$airHandlerUnitId/': {
      id: '/_authenticated/buildings_/$buildingId/air-handler-units/$airHandlerUnitId/'
      path: '/'
      fullPath: '/buildings/$buildingId/air-handler-units/$airHandlerUnitId/'
      preLoaderRoute: typeof AuthenticatedBuildingsBuildingIdAirHandlerUnitsAirHandlerUnitIdIndexRouteImport
      parentRoute: typeof AuthenticatedBuildingsBuildingIdAirHandlerUnitsAirHandlerUnitIdRouteRoute
    }
    '/_authenticated/buildings_/$buildingId/air-handler-units/$airHandlerUnitId/settings': {
      id: '/_authenticated/buildings_/$buildingId/air-handler-units/$airHandlerUnitId/settings'
      path: '/settings'
      fullPath: '/buildings/$buildingId/air-handler-units/$airHandlerUnitId/settings'
      preLoaderRoute: typeof AuthenticatedBuildingsBuildingIdAirHandlerUnitsAirHandlerUnitIdSettingsRouteRouteImport
      parentRoute: typeof AuthenticatedBuildingsBuildingIdAirHandlerUnitsAirHandlerUnitIdRouteRoute
    }
    '/_authenticated/buildings_/$buildingId/settings/bms/ahu-groups': {
      id: '/_authenticated/buildings_/$buildingId/settings/bms/ahu-groups'
      path: '/bms/ahu-groups'
      fullPath: '/buildings/$buildingId/settings/bms/ahu-groups'
      preLoaderRoute: typeof AuthenticatedBuildingsBuildingIdSettingsBmsAhuGroupsRouteImport
      parentRoute: typeof AuthenticatedBuildingsBuildingIdSettingsRouteRoute
    }
    '/_authenticated/buildings_/$buildingId/settings/bms/modules': {
      id: '/_authenticated/buildings_/$buildingId/settings/bms/modules'
      path: '/bms/modules'
      fullPath: '/buildings/$buildingId/settings/bms/modules'
      preLoaderRoute: typeof AuthenticatedBuildingsBuildingIdSettingsBmsModulesRouteImport
      parentRoute: typeof AuthenticatedBuildingsBuildingIdSettingsRouteRoute
    }
    '/_authenticated/buildings_/$buildingId/settings/bms/pages': {
      id: '/_authenticated/buildings_/$buildingId/settings/bms/pages'
      path: '/bms/pages'
      fullPath: '/buildings/$buildingId/settings/bms/pages'
      preLoaderRoute: typeof AuthenticatedBuildingsBuildingIdSettingsBmsPagesRouteImport
      parentRoute: typeof AuthenticatedBuildingsBuildingIdSettingsRouteRoute
    }
    '/_authenticated/buildings_/$buildingId/settings/buildings/general': {
      id: '/_authenticated/buildings_/$buildingId/settings/buildings/general'
      path: '/buildings/general'
      fullPath: '/buildings/$buildingId/settings/buildings/general'
      preLoaderRoute: typeof AuthenticatedBuildingsBuildingIdSettingsBuildingsGeneralRouteImport
      parentRoute: typeof AuthenticatedBuildingsBuildingIdSettingsRouteRoute
    }
    '/_authenticated/buildings_/$buildingId/settings/buildings/holidays': {
      id: '/_authenticated/buildings_/$buildingId/settings/buildings/holidays'
      path: '/buildings/holidays'
      fullPath: '/buildings/$buildingId/settings/buildings/holidays'
      preLoaderRoute: typeof AuthenticatedBuildingsBuildingIdSettingsBuildingsHolidaysRouteImport
      parentRoute: typeof AuthenticatedBuildingsBuildingIdSettingsRouteRoute
    }
    '/_authenticated/buildings_/$buildingId/settings/buildings/season': {
      id: '/_authenticated/buildings_/$buildingId/settings/buildings/season'
      path: '/buildings/season'
      fullPath: '/buildings/$buildingId/settings/buildings/season'
      preLoaderRoute: typeof AuthenticatedBuildingsBuildingIdSettingsBuildingsSeasonRouteImport
      parentRoute: typeof AuthenticatedBuildingsBuildingIdSettingsRouteRoute
    }
    '/_authenticated/buildings_/$buildingId/settings/buildings/temperatures': {
      id: '/_authenticated/buildings_/$buildingId/settings/buildings/temperatures'
      path: '/buildings/temperatures'
      fullPath: '/buildings/$buildingId/settings/buildings/temperatures'
      preLoaderRoute: typeof AuthenticatedBuildingsBuildingIdSettingsBuildingsTemperaturesRouteImport
      parentRoute: typeof AuthenticatedBuildingsBuildingIdSettingsRouteRoute
    }
    '/_authenticated/buildings_/$buildingId/settings/rooms/functions': {
      id: '/_authenticated/buildings_/$buildingId/settings/rooms/functions'
      path: '/rooms/functions'
      fullPath: '/buildings/$buildingId/settings/rooms/functions'
      preLoaderRoute: typeof AuthenticatedBuildingsBuildingIdSettingsRoomsFunctionsRouteImport
      parentRoute: typeof AuthenticatedBuildingsBuildingIdSettingsRouteRoute
    }
    '/_authenticated/buildings_/$buildingId/settings/rooms/groups': {
      id: '/_authenticated/buildings_/$buildingId/settings/rooms/groups'
      path: '/rooms/groups'
      fullPath: '/buildings/$buildingId/settings/rooms/groups'
      preLoaderRoute: typeof AuthenticatedBuildingsBuildingIdSettingsRoomsGroupsRouteImport
      parentRoute: typeof AuthenticatedBuildingsBuildingIdSettingsRouteRoute
    }
    '/_authenticated/buildings_/$buildingId/settings/rooms/holidays': {
      id: '/_authenticated/buildings_/$buildingId/settings/rooms/holidays'
      path: '/rooms/holidays'
      fullPath: '/buildings/$buildingId/settings/rooms/holidays'
      preLoaderRoute: typeof AuthenticatedBuildingsBuildingIdSettingsRoomsHolidaysRouteImport
      parentRoute: typeof AuthenticatedBuildingsBuildingIdSettingsRouteRoute
    }
    '/_authenticated/buildings_/$buildingId/settings/rooms/planning': {
      id: '/_authenticated/buildings_/$buildingId/settings/rooms/planning'
      path: '/rooms/planning'
      fullPath: '/buildings/$buildingId/settings/rooms/planning'
      preLoaderRoute: typeof AuthenticatedBuildingsBuildingIdSettingsRoomsPlanningRouteImport
      parentRoute: typeof AuthenticatedBuildingsBuildingIdSettingsRouteRoute
    }
    '/_authenticated/buildings_/$buildingId/settings/rooms/type-temp': {
      id: '/_authenticated/buildings_/$buildingId/settings/rooms/type-temp'
      path: '/rooms/type-temp'
      fullPath: '/buildings/$buildingId/settings/rooms/type-temp'
      preLoaderRoute: typeof AuthenticatedBuildingsBuildingIdSettingsRoomsTypeTempRouteImport
      parentRoute: typeof AuthenticatedBuildingsBuildingIdSettingsRouteRoute
    }
    '/_authenticated/buildings_/$buildingId/air-handler-units/$airHandlerUnitId/settings/free-cooling': {
      id: '/_authenticated/buildings_/$buildingId/air-handler-units/$airHandlerUnitId/settings/free-cooling'
      path: '/free-cooling'
      fullPath: '/buildings/$buildingId/air-handler-units/$airHandlerUnitId/settings/free-cooling'
      preLoaderRoute: typeof AuthenticatedBuildingsBuildingIdAirHandlerUnitsAirHandlerUnitIdSettingsFreeCoolingRouteImport
      parentRoute: typeof AuthenticatedBuildingsBuildingIdAirHandlerUnitsAirHandlerUnitIdSettingsRouteRoute
    }
    '/_authenticated/buildings_/$buildingId/air-handler-units/$airHandlerUnitId/settings/general': {
      id: '/_authenticated/buildings_/$buildingId/air-handler-units/$airHandlerUnitId/settings/general'
      path: '/general'
      fullPath: '/buildings/$buildingId/air-handler-units/$airHandlerUnitId/settings/general'
      preLoaderRoute: typeof AuthenticatedBuildingsBuildingIdAirHandlerUnitsAirHandlerUnitIdSettingsGeneralRouteImport
      parentRoute: typeof AuthenticatedBuildingsBuildingIdAirHandlerUnitsAirHandlerUnitIdSettingsRouteRoute
    }
    '/_authenticated/buildings_/$buildingId/air-handler-units/$airHandlerUnitId/settings/planning': {
      id: '/_authenticated/buildings_/$buildingId/air-handler-units/$airHandlerUnitId/settings/planning'
      path: '/planning'
      fullPath: '/buildings/$buildingId/air-handler-units/$airHandlerUnitId/settings/planning'
      preLoaderRoute: typeof AuthenticatedBuildingsBuildingIdAirHandlerUnitsAirHandlerUnitIdSettingsPlanningRouteImport
      parentRoute: typeof AuthenticatedBuildingsBuildingIdAirHandlerUnitsAirHandlerUnitIdSettingsRouteRoute
    }
    '/_authenticated/buildings_/$buildingId/air-handler-units/$airHandlerUnitId/settings/setpoint': {
      id: '/_authenticated/buildings_/$buildingId/air-handler-units/$airHandlerUnitId/settings/setpoint'
      path: '/setpoint'
      fullPath: '/buildings/$buildingId/air-handler-units/$airHandlerUnitId/settings/setpoint'
      preLoaderRoute: typeof AuthenticatedBuildingsBuildingIdAirHandlerUnitsAirHandlerUnitIdSettingsSetpointRouteImport
      parentRoute: typeof AuthenticatedBuildingsBuildingIdAirHandlerUnitsAirHandlerUnitIdSettingsRouteRoute
    }
    '/_authenticated/buildings_/$buildingId/boiler-rooms_/$boilerRoomId_/heating-networks/$heatingNetworkId': {
      id: '/_authenticated/buildings_/$buildingId/boiler-rooms_/$boilerRoomId_/heating-networks/$heatingNetworkId'
      path: '/boiler-rooms/$boilerRoomId/heating-networks/$heatingNetworkId'
      fullPath: '/buildings/$buildingId/boiler-rooms/$boilerRoomId/heating-networks/$heatingNetworkId'
      preLoaderRoute: typeof AuthenticatedBuildingsBuildingIdBoilerRoomsBoilerRoomIdHeatingNetworksHeatingNetworkIdRouteImport
      parentRoute: typeof AuthenticatedBuildingsBuildingIdRouteRoute
    }
    '/_authenticated/buildings_/$buildingId/floors_/$floorId_/rooms/$roomId': {
      id: '/_authenticated/buildings_/$buildingId/floors_/$floorId_/rooms/$roomId'
      path: '/floors/$floorId/rooms/$roomId'
      fullPath: '/buildings/$buildingId/floors/$floorId/rooms/$roomId'
      preLoaderRoute: typeof AuthenticatedBuildingsBuildingIdFloorsFloorIdRoomsRoomIdRouteImport
      parentRoute: typeof AuthenticatedBuildingsBuildingIdRouteRoute
    }
    '/_authenticated/buildings_/$buildingId/settings/bms/modules/': {
      id: '/_authenticated/buildings_/$buildingId/settings/bms/modules/'
      path: '/'
      fullPath: '/buildings/$buildingId/settings/bms/modules/'
      preLoaderRoute: typeof AuthenticatedBuildingsBuildingIdSettingsBmsModulesIndexRouteImport
      parentRoute: typeof AuthenticatedBuildingsBuildingIdSettingsBmsModulesRoute
    }
    '/_authenticated/buildings_/$buildingId/settings/bms/modules/$moduleId': {
      id: '/_authenticated/buildings_/$buildingId/settings/bms/modules/$moduleId'
      path: '/$moduleId'
      fullPath: '/buildings/$buildingId/settings/bms/modules/$moduleId'
      preLoaderRoute: typeof AuthenticatedBuildingsBuildingIdSettingsBmsModulesModuleIdRouteImport
      parentRoute: typeof AuthenticatedBuildingsBuildingIdSettingsBmsModulesRoute
    }
  }
}

interface AuthenticatedNoBuildingGroupsGroupIdRouteRouteChildren {
  AuthenticatedNoBuildingGroupsGroupIdBuildingsRoute: typeof AuthenticatedNoBuildingGroupsGroupIdBuildingsRoute
  AuthenticatedNoBuildingGroupsGroupIdUsersRoute: typeof AuthenticatedNoBuildingGroupsGroupIdUsersRoute
}

const AuthenticatedNoBuildingGroupsGroupIdRouteRouteChildren: AuthenticatedNoBuildingGroupsGroupIdRouteRouteChildren =
  {
    AuthenticatedNoBuildingGroupsGroupIdBuildingsRoute:
      AuthenticatedNoBuildingGroupsGroupIdBuildingsRoute,
    AuthenticatedNoBuildingGroupsGroupIdUsersRoute:
      AuthenticatedNoBuildingGroupsGroupIdUsersRoute,
  }

const AuthenticatedNoBuildingGroupsGroupIdRouteRouteWithChildren =
  AuthenticatedNoBuildingGroupsGroupIdRouteRoute._addFileChildren(
    AuthenticatedNoBuildingGroupsGroupIdRouteRouteChildren,
  )

interface AuthenticatedNoBuildingRouteRouteChildren {
  AuthenticatedNoBuildingAccountRoute: typeof AuthenticatedNoBuildingAccountRoute
  AuthenticatedNoBuildingBuildingsRoute: typeof AuthenticatedNoBuildingBuildingsRoute
  AuthenticatedNoBuildingGroupsGroupIdRouteRoute: typeof AuthenticatedNoBuildingGroupsGroupIdRouteRouteWithChildren
  AuthenticatedNoBuildingResourcesSplatRoute: typeof AuthenticatedNoBuildingResourcesSplatRoute
  AuthenticatedNoBuildingGroupsIndexRoute: typeof AuthenticatedNoBuildingGroupsIndexRoute
}

const AuthenticatedNoBuildingRouteRouteChildren: AuthenticatedNoBuildingRouteRouteChildren =
  {
    AuthenticatedNoBuildingAccountRoute: AuthenticatedNoBuildingAccountRoute,
    AuthenticatedNoBuildingBuildingsRoute:
      AuthenticatedNoBuildingBuildingsRoute,
    AuthenticatedNoBuildingGroupsGroupIdRouteRoute:
      AuthenticatedNoBuildingGroupsGroupIdRouteRouteWithChildren,
    AuthenticatedNoBuildingResourcesSplatRoute:
      AuthenticatedNoBuildingResourcesSplatRoute,
    AuthenticatedNoBuildingGroupsIndexRoute:
      AuthenticatedNoBuildingGroupsIndexRoute,
  }

const AuthenticatedNoBuildingRouteRouteWithChildren =
  AuthenticatedNoBuildingRouteRoute._addFileChildren(
    AuthenticatedNoBuildingRouteRouteChildren,
  )

interface AuthenticatedBuildingsBuildingIdConsumptionRouteRouteChildren {
  AuthenticatedBuildingsBuildingIdConsumptionMeterIdRoute: typeof AuthenticatedBuildingsBuildingIdConsumptionMeterIdRoute
  AuthenticatedBuildingsBuildingIdConsumptionIndexRoute: typeof AuthenticatedBuildingsBuildingIdConsumptionIndexRoute
}

const AuthenticatedBuildingsBuildingIdConsumptionRouteRouteChildren: AuthenticatedBuildingsBuildingIdConsumptionRouteRouteChildren =
  {
    AuthenticatedBuildingsBuildingIdConsumptionMeterIdRoute:
      AuthenticatedBuildingsBuildingIdConsumptionMeterIdRoute,
    AuthenticatedBuildingsBuildingIdConsumptionIndexRoute:
      AuthenticatedBuildingsBuildingIdConsumptionIndexRoute,
  }

const AuthenticatedBuildingsBuildingIdConsumptionRouteRouteWithChildren =
  AuthenticatedBuildingsBuildingIdConsumptionRouteRoute._addFileChildren(
    AuthenticatedBuildingsBuildingIdConsumptionRouteRouteChildren,
  )

interface AuthenticatedBuildingsBuildingIdMaintenanceRouteRouteChildren {
  AuthenticatedBuildingsBuildingIdMaintenanceAdvancedRoute: typeof AuthenticatedBuildingsBuildingIdMaintenanceAdvancedRoute
  AuthenticatedBuildingsBuildingIdMaintenanceIndexRoute: typeof AuthenticatedBuildingsBuildingIdMaintenanceIndexRoute
}

const AuthenticatedBuildingsBuildingIdMaintenanceRouteRouteChildren: AuthenticatedBuildingsBuildingIdMaintenanceRouteRouteChildren =
  {
    AuthenticatedBuildingsBuildingIdMaintenanceAdvancedRoute:
      AuthenticatedBuildingsBuildingIdMaintenanceAdvancedRoute,
    AuthenticatedBuildingsBuildingIdMaintenanceIndexRoute:
      AuthenticatedBuildingsBuildingIdMaintenanceIndexRoute,
  }

const AuthenticatedBuildingsBuildingIdMaintenanceRouteRouteWithChildren =
  AuthenticatedBuildingsBuildingIdMaintenanceRouteRoute._addFileChildren(
    AuthenticatedBuildingsBuildingIdMaintenanceRouteRouteChildren,
  )

interface AuthenticatedBuildingsBuildingIdSettingsBmsModulesRouteChildren {
  AuthenticatedBuildingsBuildingIdSettingsBmsModulesModuleIdRoute: typeof AuthenticatedBuildingsBuildingIdSettingsBmsModulesModuleIdRoute
  AuthenticatedBuildingsBuildingIdSettingsBmsModulesIndexRoute: typeof AuthenticatedBuildingsBuildingIdSettingsBmsModulesIndexRoute
}

const AuthenticatedBuildingsBuildingIdSettingsBmsModulesRouteChildren: AuthenticatedBuildingsBuildingIdSettingsBmsModulesRouteChildren =
  {
    AuthenticatedBuildingsBuildingIdSettingsBmsModulesModuleIdRoute:
      AuthenticatedBuildingsBuildingIdSettingsBmsModulesModuleIdRoute,
    AuthenticatedBuildingsBuildingIdSettingsBmsModulesIndexRoute:
      AuthenticatedBuildingsBuildingIdSettingsBmsModulesIndexRoute,
  }

const AuthenticatedBuildingsBuildingIdSettingsBmsModulesRouteWithChildren =
  AuthenticatedBuildingsBuildingIdSettingsBmsModulesRoute._addFileChildren(
    AuthenticatedBuildingsBuildingIdSettingsBmsModulesRouteChildren,
  )

interface AuthenticatedBuildingsBuildingIdSettingsRouteRouteChildren {
  AuthenticatedBuildingsBuildingIdSettingsBmsAhuGroupsRoute: typeof AuthenticatedBuildingsBuildingIdSettingsBmsAhuGroupsRoute
  AuthenticatedBuildingsBuildingIdSettingsBmsModulesRoute: typeof AuthenticatedBuildingsBuildingIdSettingsBmsModulesRouteWithChildren
  AuthenticatedBuildingsBuildingIdSettingsBmsPagesRoute: typeof AuthenticatedBuildingsBuildingIdSettingsBmsPagesRoute
  AuthenticatedBuildingsBuildingIdSettingsBuildingsGeneralRoute: typeof AuthenticatedBuildingsBuildingIdSettingsBuildingsGeneralRoute
  AuthenticatedBuildingsBuildingIdSettingsBuildingsHolidaysRoute: typeof AuthenticatedBuildingsBuildingIdSettingsBuildingsHolidaysRoute
  AuthenticatedBuildingsBuildingIdSettingsBuildingsSeasonRoute: typeof AuthenticatedBuildingsBuildingIdSettingsBuildingsSeasonRoute
  AuthenticatedBuildingsBuildingIdSettingsBuildingsTemperaturesRoute: typeof AuthenticatedBuildingsBuildingIdSettingsBuildingsTemperaturesRoute
  AuthenticatedBuildingsBuildingIdSettingsRoomsFunctionsRoute: typeof AuthenticatedBuildingsBuildingIdSettingsRoomsFunctionsRoute
  AuthenticatedBuildingsBuildingIdSettingsRoomsGroupsRoute: typeof AuthenticatedBuildingsBuildingIdSettingsRoomsGroupsRoute
  AuthenticatedBuildingsBuildingIdSettingsRoomsHolidaysRoute: typeof AuthenticatedBuildingsBuildingIdSettingsRoomsHolidaysRoute
  AuthenticatedBuildingsBuildingIdSettingsRoomsPlanningRoute: typeof AuthenticatedBuildingsBuildingIdSettingsRoomsPlanningRoute
  AuthenticatedBuildingsBuildingIdSettingsRoomsTypeTempRoute: typeof AuthenticatedBuildingsBuildingIdSettingsRoomsTypeTempRoute
}

const AuthenticatedBuildingsBuildingIdSettingsRouteRouteChildren: AuthenticatedBuildingsBuildingIdSettingsRouteRouteChildren =
  {
    AuthenticatedBuildingsBuildingIdSettingsBmsAhuGroupsRoute:
      AuthenticatedBuildingsBuildingIdSettingsBmsAhuGroupsRoute,
    AuthenticatedBuildingsBuildingIdSettingsBmsModulesRoute:
      AuthenticatedBuildingsBuildingIdSettingsBmsModulesRouteWithChildren,
    AuthenticatedBuildingsBuildingIdSettingsBmsPagesRoute:
      AuthenticatedBuildingsBuildingIdSettingsBmsPagesRoute,
    AuthenticatedBuildingsBuildingIdSettingsBuildingsGeneralRoute:
      AuthenticatedBuildingsBuildingIdSettingsBuildingsGeneralRoute,
    AuthenticatedBuildingsBuildingIdSettingsBuildingsHolidaysRoute:
      AuthenticatedBuildingsBuildingIdSettingsBuildingsHolidaysRoute,
    AuthenticatedBuildingsBuildingIdSettingsBuildingsSeasonRoute:
      AuthenticatedBuildingsBuildingIdSettingsBuildingsSeasonRoute,
    AuthenticatedBuildingsBuildingIdSettingsBuildingsTemperaturesRoute:
      AuthenticatedBuildingsBuildingIdSettingsBuildingsTemperaturesRoute,
    AuthenticatedBuildingsBuildingIdSettingsRoomsFunctionsRoute:
      AuthenticatedBuildingsBuildingIdSettingsRoomsFunctionsRoute,
    AuthenticatedBuildingsBuildingIdSettingsRoomsGroupsRoute:
      AuthenticatedBuildingsBuildingIdSettingsRoomsGroupsRoute,
    AuthenticatedBuildingsBuildingIdSettingsRoomsHolidaysRoute:
      AuthenticatedBuildingsBuildingIdSettingsRoomsHolidaysRoute,
    AuthenticatedBuildingsBuildingIdSettingsRoomsPlanningRoute:
      AuthenticatedBuildingsBuildingIdSettingsRoomsPlanningRoute,
    AuthenticatedBuildingsBuildingIdSettingsRoomsTypeTempRoute:
      AuthenticatedBuildingsBuildingIdSettingsRoomsTypeTempRoute,
  }

const AuthenticatedBuildingsBuildingIdSettingsRouteRouteWithChildren =
  AuthenticatedBuildingsBuildingIdSettingsRouteRoute._addFileChildren(
    AuthenticatedBuildingsBuildingIdSettingsRouteRouteChildren,
  )

interface AuthenticatedBuildingsBuildingIdAirHandlerUnitsAirHandlerUnitIdSettingsRouteRouteChildren {
  AuthenticatedBuildingsBuildingIdAirHandlerUnitsAirHandlerUnitIdSettingsFreeCoolingRoute: typeof AuthenticatedBuildingsBuildingIdAirHandlerUnitsAirHandlerUnitIdSettingsFreeCoolingRoute
  AuthenticatedBuildingsBuildingIdAirHandlerUnitsAirHandlerUnitIdSettingsGeneralRoute: typeof AuthenticatedBuildingsBuildingIdAirHandlerUnitsAirHandlerUnitIdSettingsGeneralRoute
  AuthenticatedBuildingsBuildingIdAirHandlerUnitsAirHandlerUnitIdSettingsPlanningRoute: typeof AuthenticatedBuildingsBuildingIdAirHandlerUnitsAirHandlerUnitIdSettingsPlanningRoute
  AuthenticatedBuildingsBuildingIdAirHandlerUnitsAirHandlerUnitIdSettingsSetpointRoute: typeof AuthenticatedBuildingsBuildingIdAirHandlerUnitsAirHandlerUnitIdSettingsSetpointRoute
}

const AuthenticatedBuildingsBuildingIdAirHandlerUnitsAirHandlerUnitIdSettingsRouteRouteChildren: AuthenticatedBuildingsBuildingIdAirHandlerUnitsAirHandlerUnitIdSettingsRouteRouteChildren =
  {
    AuthenticatedBuildingsBuildingIdAirHandlerUnitsAirHandlerUnitIdSettingsFreeCoolingRoute:
      AuthenticatedBuildingsBuildingIdAirHandlerUnitsAirHandlerUnitIdSettingsFreeCoolingRoute,
    AuthenticatedBuildingsBuildingIdAirHandlerUnitsAirHandlerUnitIdSettingsGeneralRoute:
      AuthenticatedBuildingsBuildingIdAirHandlerUnitsAirHandlerUnitIdSettingsGeneralRoute,
    AuthenticatedBuildingsBuildingIdAirHandlerUnitsAirHandlerUnitIdSettingsPlanningRoute:
      AuthenticatedBuildingsBuildingIdAirHandlerUnitsAirHandlerUnitIdSettingsPlanningRoute,
    AuthenticatedBuildingsBuildingIdAirHandlerUnitsAirHandlerUnitIdSettingsSetpointRoute:
      AuthenticatedBuildingsBuildingIdAirHandlerUnitsAirHandlerUnitIdSettingsSetpointRoute,
  }

const AuthenticatedBuildingsBuildingIdAirHandlerUnitsAirHandlerUnitIdSettingsRouteRouteWithChildren =
  AuthenticatedBuildingsBuildingIdAirHandlerUnitsAirHandlerUnitIdSettingsRouteRoute._addFileChildren(
    AuthenticatedBuildingsBuildingIdAirHandlerUnitsAirHandlerUnitIdSettingsRouteRouteChildren,
  )

interface AuthenticatedBuildingsBuildingIdAirHandlerUnitsAirHandlerUnitIdRouteRouteChildren {
  AuthenticatedBuildingsBuildingIdAirHandlerUnitsAirHandlerUnitIdSettingsRouteRoute: typeof AuthenticatedBuildingsBuildingIdAirHandlerUnitsAirHandlerUnitIdSettingsRouteRouteWithChildren
  AuthenticatedBuildingsBuildingIdAirHandlerUnitsAirHandlerUnitIdIndexRoute: typeof AuthenticatedBuildingsBuildingIdAirHandlerUnitsAirHandlerUnitIdIndexRoute
}

const AuthenticatedBuildingsBuildingIdAirHandlerUnitsAirHandlerUnitIdRouteRouteChildren: AuthenticatedBuildingsBuildingIdAirHandlerUnitsAirHandlerUnitIdRouteRouteChildren =
  {
    AuthenticatedBuildingsBuildingIdAirHandlerUnitsAirHandlerUnitIdSettingsRouteRoute:
      AuthenticatedBuildingsBuildingIdAirHandlerUnitsAirHandlerUnitIdSettingsRouteRouteWithChildren,
    AuthenticatedBuildingsBuildingIdAirHandlerUnitsAirHandlerUnitIdIndexRoute:
      AuthenticatedBuildingsBuildingIdAirHandlerUnitsAirHandlerUnitIdIndexRoute,
  }

const AuthenticatedBuildingsBuildingIdAirHandlerUnitsAirHandlerUnitIdRouteRouteWithChildren =
  AuthenticatedBuildingsBuildingIdAirHandlerUnitsAirHandlerUnitIdRouteRoute._addFileChildren(
    AuthenticatedBuildingsBuildingIdAirHandlerUnitsAirHandlerUnitIdRouteRouteChildren,
  )

interface AuthenticatedBuildingsBuildingIdRouteRouteChildren {
  AuthenticatedBuildingsBuildingIdConsumptionRouteRoute: typeof AuthenticatedBuildingsBuildingIdConsumptionRouteRouteWithChildren
  AuthenticatedBuildingsBuildingIdMaintenanceRouteRoute: typeof AuthenticatedBuildingsBuildingIdMaintenanceRouteRouteWithChildren
  AuthenticatedBuildingsBuildingIdSettingsRouteRoute: typeof AuthenticatedBuildingsBuildingIdSettingsRouteRouteWithChildren
  AuthenticatedBuildingsBuildingIdAlarmsRoute: typeof AuthenticatedBuildingsBuildingIdAlarmsRoute
  AuthenticatedBuildingsBuildingIdBmsRoute: typeof AuthenticatedBuildingsBuildingIdBmsRoute
  AuthenticatedBuildingsBuildingIdDashboardRoute: typeof AuthenticatedBuildingsBuildingIdDashboardRoute
  AuthenticatedBuildingsBuildingIdFloorsRoute: typeof AuthenticatedBuildingsBuildingIdFloorsRoute
  AuthenticatedBuildingsBuildingIdUsersRoute: typeof AuthenticatedBuildingsBuildingIdUsersRoute
  AuthenticatedBuildingsBuildingIdIndexRoute: typeof AuthenticatedBuildingsBuildingIdIndexRoute
  AuthenticatedBuildingsBuildingIdAirHandlerUnitsAirHandlerUnitIdRouteRoute: typeof AuthenticatedBuildingsBuildingIdAirHandlerUnitsAirHandlerUnitIdRouteRouteWithChildren
  AuthenticatedBuildingsBuildingIdBoilerRoomsBoilerRoomIdRoute: typeof AuthenticatedBuildingsBuildingIdBoilerRoomsBoilerRoomIdRoute
  AuthenticatedBuildingsBuildingIdFloorsFloorIdRoute: typeof AuthenticatedBuildingsBuildingIdFloorsFloorIdRoute
  AuthenticatedBuildingsBuildingIdResourcesSplatRoute: typeof AuthenticatedBuildingsBuildingIdResourcesSplatRoute
  AuthenticatedBuildingsBuildingIdBoilerRoomsIndexRoute: typeof AuthenticatedBuildingsBuildingIdBoilerRoomsIndexRoute
  AuthenticatedBuildingsBuildingIdBoilerRoomsBoilerRoomIdHeatingNetworksHeatingNetworkIdRoute: typeof AuthenticatedBuildingsBuildingIdBoilerRoomsBoilerRoomIdHeatingNetworksHeatingNetworkIdRoute
  AuthenticatedBuildingsBuildingIdFloorsFloorIdRoomsRoomIdRoute: typeof AuthenticatedBuildingsBuildingIdFloorsFloorIdRoomsRoomIdRoute
}

const AuthenticatedBuildingsBuildingIdRouteRouteChildren: AuthenticatedBuildingsBuildingIdRouteRouteChildren =
  {
    AuthenticatedBuildingsBuildingIdConsumptionRouteRoute:
      AuthenticatedBuildingsBuildingIdConsumptionRouteRouteWithChildren,
    AuthenticatedBuildingsBuildingIdMaintenanceRouteRoute:
      AuthenticatedBuildingsBuildingIdMaintenanceRouteRouteWithChildren,
    AuthenticatedBuildingsBuildingIdSettingsRouteRoute:
      AuthenticatedBuildingsBuildingIdSettingsRouteRouteWithChildren,
    AuthenticatedBuildingsBuildingIdAlarmsRoute:
      AuthenticatedBuildingsBuildingIdAlarmsRoute,
    AuthenticatedBuildingsBuildingIdBmsRoute:
      AuthenticatedBuildingsBuildingIdBmsRoute,
    AuthenticatedBuildingsBuildingIdDashboardRoute:
      AuthenticatedBuildingsBuildingIdDashboardRoute,
    AuthenticatedBuildingsBuildingIdFloorsRoute:
      AuthenticatedBuildingsBuildingIdFloorsRoute,
    AuthenticatedBuildingsBuildingIdUsersRoute:
      AuthenticatedBuildingsBuildingIdUsersRoute,
    AuthenticatedBuildingsBuildingIdIndexRoute:
      AuthenticatedBuildingsBuildingIdIndexRoute,
    AuthenticatedBuildingsBuildingIdAirHandlerUnitsAirHandlerUnitIdRouteRoute:
      AuthenticatedBuildingsBuildingIdAirHandlerUnitsAirHandlerUnitIdRouteRouteWithChildren,
    AuthenticatedBuildingsBuildingIdBoilerRoomsBoilerRoomIdRoute:
      AuthenticatedBuildingsBuildingIdBoilerRoomsBoilerRoomIdRoute,
    AuthenticatedBuildingsBuildingIdFloorsFloorIdRoute:
      AuthenticatedBuildingsBuildingIdFloorsFloorIdRoute,
    AuthenticatedBuildingsBuildingIdResourcesSplatRoute:
      AuthenticatedBuildingsBuildingIdResourcesSplatRoute,
    AuthenticatedBuildingsBuildingIdBoilerRoomsIndexRoute:
      AuthenticatedBuildingsBuildingIdBoilerRoomsIndexRoute,
    AuthenticatedBuildingsBuildingIdBoilerRoomsBoilerRoomIdHeatingNetworksHeatingNetworkIdRoute:
      AuthenticatedBuildingsBuildingIdBoilerRoomsBoilerRoomIdHeatingNetworksHeatingNetworkIdRoute,
    AuthenticatedBuildingsBuildingIdFloorsFloorIdRoomsRoomIdRoute:
      AuthenticatedBuildingsBuildingIdFloorsFloorIdRoomsRoomIdRoute,
  }

const AuthenticatedBuildingsBuildingIdRouteRouteWithChildren =
  AuthenticatedBuildingsBuildingIdRouteRoute._addFileChildren(
    AuthenticatedBuildingsBuildingIdRouteRouteChildren,
  )

interface AuthenticatedRouteRouteChildren {
  AuthenticatedNoBuildingRouteRoute: typeof AuthenticatedNoBuildingRouteRouteWithChildren
  AuthenticatedBuildingsBuildingIdRouteRoute: typeof AuthenticatedBuildingsBuildingIdRouteRouteWithChildren
}

const AuthenticatedRouteRouteChildren: AuthenticatedRouteRouteChildren = {
  AuthenticatedNoBuildingRouteRoute:
    AuthenticatedNoBuildingRouteRouteWithChildren,
  AuthenticatedBuildingsBuildingIdRouteRoute:
    AuthenticatedBuildingsBuildingIdRouteRouteWithChildren,
}

const AuthenticatedRouteRouteWithChildren =
  AuthenticatedRouteRoute._addFileChildren(AuthenticatedRouteRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthenticatedRouteRoute: AuthenticatedRouteRouteWithChildren,
  ExpiredTokenRoute: ExpiredTokenRoute,
  RecoverAccountRoute: RecoverAccountRoute,
  SignInRoute: SignInRoute,
  UsedTokenRoute: UsedTokenRoute,
  EnrollAccountTokenRoute: EnrollAccountTokenRoute,
  ResetPasswordTokenRoute: ResetPasswordTokenRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
